<template>
  <div class="order_form_page">
    <!-- 自命名下单组件 -->
    <div class="custom-order-container" v-if="customOrderVisible" :class="{ 'collapsed': customOrderCollapsed }">
      <div class="custom-order-header">
        <div class="custom-order-toggle">
          <el-button size="mini" @click="toggleCustomOrderList">
            <i :class="customOrderCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'" aria-hidden="true"></i>
          </el-button>
        </div>
        <div class="custom-order-title">
          <h3>自命名下单</h3>
        </div>
      </div>
      
      <!-- 订单列表区域 -->
      <div class="custom-order-list" v-if="!customOrderCollapsed && customOrderListVisible">
        <h3>订单列表</h3>
        <el-table :data="customOrders" style="width: 100%" empty-text="暂无订单">
          <el-table-column prop="checkInfo" label="订单内容">
            <template slot-scope="scope">
              {{ scope.row.checkInfo.paperSizeHeight }}x{{ scope.row.checkInfo.paperSizeWeight }}mm - {{ scope.row.checkInfo.orderNum }}张
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag type="success">识别成功</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="orderTotalPrice" label="价格">
            <template slot-scope="scope">
              ￥{{ scope.row.orderTotalPrice }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="removeCustomOrder(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 底部结算区域 -->
      <div v-if="!customOrderCollapsed && customOrders.length > 0" class="custom-order-footer">
        <div class="custom-order-total">
          总计：<span style="font-weight: bold; color: #00a0e9;padding-right:10px;">￥{{ customOrderTotalPrice }}</span>可消费金额：<span style="font-weight: bold; color: #00a0e9;">￥{{ personalInfo.balance }}</span>
        </div>
        <div style="text-align: right;">
          <el-button type="warning" @click="customOrderCheckout" v-if="Number(personalInfo.balance) >= Number(customOrderTotalPrice)">
            余额支付
          </el-button>
          <el-button type="primary" @click="toRecharge">
            余额充值
          </el-button>
          <el-button type="primary" @click="scanOrder">
            扫码支付
          </el-button>
        </div>
      </div>
    </div>
    
    <div class="title_box">
      <div class="title">{{ menuTitle }}</div>
      <div class="subtitle" v-if="topInfo.show">
        专属客服： {{ topInfo.customerName }} 上班时间：{{
          topInfo.workTime
        }}
          产品负责人：
        {{ topInfo.productOwnerTitle }}
        {{ topInfo.productOwnerTel }}
        <el-popover placement="top" width="100" trigger="hover" class="ml12">
          <div class="flex_center_center">
            <img :src="topInfo.productOwnerWxUrl" class="detail_img" style="width: 150px" />
          </div>
          <img slot="reference" :src="topInfo.productOwnerWxUrl" class="small_img" />
        </el-popover>
      </div>
    </div>
    <!-- 合版不干胶 -->
    <div class="form_box" v-if="menuTitle === '合版不干胶'">
      <div class="item_box">
        <div class="item_label required">不干胶类型</div>
        <div class="item_content">
          <el-tabs v-model="parentId" type="card" @tab-click="getcategory()">
            <el-tab-pane label="分切不干胶" name="1">
              <div class="Materials_computer">
                <el-button v-for="(cate, cIndex) of categoryList" :key="cIndex" :class="[
                  'radio_btn',
                  cate.paperCategoryId === paperCategoryId ? 'active' : '',
                ]" @click="checkPaperCategory(cate)">
                  {{ cate.categoryName }}
                </el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="模切不干胶(啤)" name="2">
              <div class="Materials_computer">
                <el-button v-for="(cate, cIndex) of categoryList" :key="cIndex" :class="[
                  'radio_btn',
                  cate.paperCategoryId === paperCategoryId ? 'active' : '',
                ]" @click="checkPaperCategory(cate)">
                  {{ cate.categoryName }}
                </el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">成品尺寸</div>
        <div class="item_content">
          <el-input size="mini" style="width: 80px" class="mb12" placeholder="长"
            v-model="checkInfo.paperSizeHeight"></el-input>
          X
          <el-input size="mini" style="width: 80px" class="mb12 mr12" placeholder="宽"
            v-model="checkInfo.paperSizeWeight"></el-input>
          <el-radio-group v-model="checkInfo.pageSize" @input="checkpageSize">
            <el-radio v-for="(item, index) of cateConfig.paperSize" :key="index" :label="item">
              {{ item }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">出货排列</div>
        <div class="item_content">
          <div class="flex_center">
            <el-radio-group v-model="checkInfo.shipmentArrangement" class="mr12">
              <el-radio :label="item" v-for="(item, index) in cateConfig.shipmentArrangement" :key="index">{{item}}</el-radio>
            </el-radio-group>
            <div class="flex_center" v-if="checkInfo.shipmentArrangement === '单款拼大张'">
              <el-input style="width: 100px; margin-right: 4px" placeholder="长边数量" size="mini"
                v-model="checkInfo.shipmentArrangementLongSide"></el-input>
              <el-input style="width: 100px; margin-right: 4px" placeholder="短边数量" size="mini"
                v-model="checkInfo.shipmentArrangementShortSide"></el-input>
              <el-tag type="success" class="ml12 pointer" @click="toSeeShow('shipmentArrangement')">查看说明</el-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">模切类型</div>
        <div class="item_content mb40">
          <el-select v-model="checkInfo.cutType" placeholder="请选择" size="mini" style="width: 100px">
            <el-option v-for="item in cutTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-tag type="success" class="ml12 pointer" @click="toSeeShow('cutType')">查看说明</el-tag>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">覆膜</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.tectorial" @input="checktectorial">
            <el-radio :label="item.tectorial"  v-for="(item, index) in cateConfig.tectorialList" :key="index">{{ item.tectorial }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">其他工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.otherProcess" @input="checkOtherProcess">
            <el-radio :label="item.otherProcess" v-for="(item, index) in cateConfig.otherProcessList" :key="index">{{ item.otherProcess }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">印刷款数</div>
        <div class="item_content">
          <el-input-number v-model="checkInfo.printNum" controls-position="right" :min="1" size="mini"
            @change="changePrintNum"></el-input-number>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">出货数量</div>
        <div class="item_content flex">
          <div :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === item.quantity ? 'active_num' : '',
          ]" v-for="(item, index) of cateConfig.quantityPrice" :key="index" @click="checkOrderNum(item)">
            <div class="top_btn">{{ item.quantity }}</div>
            <div class="bottom_btn" v-if="item.orderPrice">
              ￥{{ item.orderPrice }}
            </div>
          </div>
          <div v-if="customizeObj.show" :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === customizeObj.quantity ? 'active_num' : '',
          ]" @click="checkOrderNum(customizeObj)">
            <div class="top_btn">{{ customizeObj.quantity }}</div>
            <div class="bottom_btn" v-if="customizeObj.orderPrice">
              ￥{{ customizeObj.orderPrice }}
            </div>
          </div>
          <div class="flex_center customize" style="height: 32px">
            自定义：
            <el-input-number style="width: 120px; height: 32px" size="small" class="mr12" :controls="false"
              v-model="customizeObj.orderNum" @change="changeOrderNum"></el-input-number>
            <el-button size="small" style="height: 32px" class="getPrice" @click="changeOrderNum">点击报价</el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label nobg">产品类型：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.productType">
            <el-radio label="宣传类不干胶">宣传类不干胶</el-radio>
            <el-radio label="商品类不干胶">商品类不干胶</el-radio>
            <el-radio label="无注册商标">无注册商标</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">配送方式：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.deliveryType" size="mini">
            <el-radio-button label="默认地址"></el-radio-button>
            <el-radio-button label="代发快递"></el-radio-button>
            <el-radio-button label="上门自取"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <template v-if="checkInfo.deliveryType === '默认地址'">
        <div class="address">
          {{ personalInfo.province }}
          {{ personalInfo.city }}
          {{ personalInfo.area }}
          {{ personalInfo.address }}, {{ personalInfo.companyContact }},
          {{ personalInfo.phone }}
        </div>
      </template>
      <template v-if="checkInfo.deliveryType === '代发快递'">
        <div class="item_box">
          <div class="item_label nobg">快递公司：</div>
          <div class="item_content">
            <el-radio-group v-model="checkInfo.expressName" size="mini" @change="getPriceFun">
              <el-radio-button :label="item.expressName" v-for="(item, index) of expressList" :key="index">
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">省市区：</div>
          <div class="item_content">
            <el-cascader v-model="checkInfo.addressArray" :options="addressOptions" :props="{ expandTrigger: 'hover' }"
              class="input_box" style="width: 250px" size="mini" @change="changeAddressArray">
            </el-cascader>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">收货地址：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.address"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系人：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.contactName"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系电话：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.phone"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">快捷输入：</div>
          <div class="item_content">
            <el-input size="mini" type="textarea" v-model="checkInfo.textarea" style="width: 250px" placeholder="请输入地址">
            </el-input>
            <el-button type="primary" size="mini" class="ml12" @click="toCheckInfo">识别</el-button>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">优惠券：</div>
          <div class="item_content flex_center">
            <div v-if="!this.checkInfo.userCouponId" class="no_coupon">
              暂未可用优惠券
            </div>
            <div v-else class="use_coupon">
              <span style="color: #00a0e9">￥{{
                userCouponInfo.couponPrice
                  ? "-" + userCouponInfo.couponPrice
                  : ""
              }}</span>
              <!-- <span v-if="userCouponInfo.couponLimitprice">
                使用规则：{{ userCouponInfo.couponLimitprice }}
              </span> -->
            </div>
            <div class="my_coupon" @click="toMycoupon" v-if="userCouponList.length > 0">
              查看可用优惠券
            </div>
          </div>
        </div>
      </template>

      <div class="offer mb12">
        <div class="params">
          <span v-if="checkInfo.paperSizeHeight && checkInfo.paperSizeWeight">
            {{ checkInfo.paperSizeHeight }}x{{ checkInfo.paperSizeWeight }}mm
          </span>
          <span v-if="checkInfo.orderNum"> -{{ checkInfo.orderNum }}张 </span>
          <span v-if="cateConfig.categoryName">
            -{{ cateConfig.categoryName }}
          </span>
          <span v-if="checkInfo.cutType"> -模切{{ checkInfo.cutType }} </span>
          <span v-if="checkInfo.shipmentArrangement">
            -{{ checkInfo.shipmentArrangement }}
          </span>
          <span v-if="checkInfo.tectorial.tectorial"> -排列方式：{{ checkInfo.tectorial.tectorial }} </span>

          <el-tag type="success" style="cursor: pointer" @click="toCopy" v-if="
            checkInfo.paperSizeHeight &&
            checkInfo.paperSizeWeight &&
            checkInfo.orderNum &&
            orderPrice
          ">复制报价总结</el-tag>
        </div>
        <div class="flex_between">
          <div class="flex_baseline price">
            <span v-if="orderPrice">价格:￥{{ orderPrice }}</span>
            <span v-else>价格:报价中...</span>
            <span v-if="userCouponInfo.userStatus">
              折扣：{{ userCouponInfo.couponPrice }}元
            </span>
            <span style="font-size: 14px; margin-left: 6px"
              v-if="freightPrice && checkInfo.deliveryType !== '上门自取'">运费：{{
              freightPrice }}元</span>
            <span style="font-size: 14px; margin-left: 6px" v-if="weight">预估重量：{{ weight }}kg</span>
          </div>
          <el-button size="small" style="color: 00a0e9; margin-right: 20px" @click="toQQ">
            <div class="btn">
              <img src="../../../assets/img/image.png" alt="" class="icon" />
              QQ交谈
            </div>
          </el-button>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">商标声明:</div>
        <div class="item_content font14px ml12">
          <el-checkbox v-model="agreeCheck"></el-checkbox>
          我同意
          <span class="agreement" @click="changeTab('6')">方和印刷版权声明</span>
          以及
          <span class="agreement" @click="changeTab('5')">知识产权要求规范</span>
        </div>
      </div>
      <div class="alret_box">
        <div class="alert mb12">
          <i class="el-icon-warning" style="margin-right: 6px; color: #faad14"></i>
          带有注册商标的说明书、合格证、产品标签、包装等订单，下单时请务必上传【品牌授权书或商标注册证书】，未提供的订单将被直接驳回，请及时关注
          我的订单-订单管理、微信消息通知，不再电话另行通知，尽情谅解！
        </div>
        <div class="tips font14px">
          告示：侵犯知识产权、色情、不法宗教、代开发票及其他违法内容均不可以下单至我司，如果发现客户下单上述违法印刷文件至本公司，客服因自动审稿没发现，导致印刷完成，我司将直接没收销毁，货款照样收取，请各位客户莫存侥幸心理，谢谢配合！
        </div>
      </div>
      <div class="flex_center_center mt40 mb100">
        <el-button class="pay_btn" style="margin-right: 250px" type="primary" @click="sureOrder"
          :disabled="!orderPrice">加入订单</el-button>
      </div>
    </div>
    <!-- 专版不干胶 -->
    <div class="form_box" v-if="menuTitle === '专版不干胶'">
      <div class="item_box">
        <div class="item_label required">成品尺寸</div>
        <div class="item_content">
          <el-input size="mini" style="width: 80px" class="mb12" placeholder="长"
            v-model="checkInfo.paperSizeHeight"></el-input>
          X
          <el-input size="mini" style="width: 80px" class="mb12 mr12" placeholder="宽"
            v-model="checkInfo.paperSizeWeight"></el-input>
          <el-radio-group v-model="checkInfo.pageSize" @input="checkpageSize">
            <el-radio v-for="(item, index) of cateConfig.paperSize" :key="index" :label="item">
              {{ item }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">材料名称</div>
        <div class="item_content">
          <div class="Materials_computer">
            <el-button v-for="(cate, cIndex) of categoryList" :key="cIndex" :class="[
              'radio_btn',
              cate.paperCategoryId === paperCategoryId ? 'active' : '',
            ]" @click="checkPaperCategory(cate)">
              {{ cate.categoryName }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">出货排列</div>
        <div class="item_content">
          <div class="flex_center">
            <el-radio-group v-model="checkInfo.shipmentArrangement" class="mr12" @change="changeShipment">
              <el-radio :label="item" v-for="(item, index) in cateConfig.shipmentArrangement" :key="index">{{item}}</el-radio> </el-radio-group>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">成品模式</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.productMode">
            <el-radio label="切成品">切成品</el-radio>
            <el-radio label="啤成品(模切)" :disabled="checkInfo.shipmentArrangement === '任意' ? false : true
              ">啤成品(模切)</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">特殊工艺</div>
        <div class="item_content">
          <el-checkbox-group v-model="checkInfo.specialProcess">
            <el-checkbox label="啤全穿"></el-checkbox>
            <el-checkbox label="单刀"></el-checkbox>
            <el-checkbox label="啤底纸"></el-checkbox>
            <el-checkbox label="烫金">
              烫金
              <span v-if="checkInfo.specialProcess.includes('烫金')">
                <el-select v-model="checkInfo.specialProcessBronzing" placeholder="请选择" size="mini"
                  style="width: 100px">
                  <el-option v-for="item in colorList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-input size="mini" style="width: 80px" placeholder="长边烫工宽度" class="mb12"
                  v-model="checkInfo.specialProcessBronzingLong"></el-input>
                X
                <el-input size="mini" style="width: 80px" placeholder="短边烫工宽度" class="mb12"
                  v-model="checkInfo.specialProcessBronzingShort"></el-input>
              </span>
            </el-checkbox>
            <el-checkbox label="局部UV">
              局部UV
              <span v-if="checkInfo.specialProcess.includes('局部UV')">
                <el-input size="mini" style="width: 120px" placeholder="长边UV宽度" class="mb12"
                  v-model="checkInfo.specialProcessUvLong"></el-input>
                X
                <el-input size="mini" style="width: 120px" placeholder="短边UV宽度" class="mb12"
                  v-model="checkInfo.specialProcessUvShort"></el-input>
              </span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">表面工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.tectorial" @input="checktectorial">
            <el-radio :label="item.tectorial" v-for="(item, index) in cateConfig.tectorialList" :key="index">{{ item.tectorial }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">其他工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.otherProcess" @input="checkOtherProcess">
            <el-radio :label="item.otherProcess" v-for="(item, index) in cateConfig.otherProcessList" :key="index">{{ item.otherProcess }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">印刷款数</div>
        <div class="item_content">
          <el-input-number v-model="checkInfo.printNum" controls-position="right" :min="1" size="mini"
            @change="changePrintNum"></el-input-number>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">成品数量：</div>
        <div class="item_content flex">
          <div :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === item.quantity ? 'active_num' : '',
          ]" v-for="(item, index) of cateConfig.quantityPrice" :key="index" @click="checkOrderNum(item)">
            <div class="top_btn">{{ item.quantity }}</div>
            <div class="bottom_btn" v-if="item.orderPrice">
              ￥{{ item.orderPrice }}
            </div>
          </div>
          <div v-if="customizeObj.show" :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === customizeObj.quantity ? 'active_num' : '',
          ]" @click="checkOrderNum(customizeObj)">
            <div class="top_btn">{{ customizeObj.quantity }}</div>
            <div class="bottom_btn" v-if="customizeObj.orderPrice">
              ￥{{ customizeObj.orderPrice }}
            </div>
          </div>
          <div class="flex_center customize" style="height: 32px">
            自定义：
            <el-input-number style="width: 120px; height: 32px" size="small" class="mr12" :controls="false"
              v-model="customizeObj.orderNum" @change="changeOrderNum"></el-input-number>
            <el-button size="small" style="height: 32px" class="getPrice" @click="changeOrderNum">点击报价</el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label nobg">产品类型：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.productType">
            <el-radio label="宣传类不干胶">宣传类不干胶</el-radio>
            <el-radio label="商品类不干胶">商品类不干胶</el-radio>
            <el-radio label="无注册商标">无注册商标</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">配送方式：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.deliveryType" size="mini">
            <el-radio-button label="默认地址"></el-radio-button>
            <el-radio-button label="代发快递"></el-radio-button>
            <el-radio-button label="上门自取"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <template v-if="checkInfo.deliveryType === '默认地址'">
        <div class="address">
          {{ personalInfo.province }}
          {{ personalInfo.city }}
          {{ personalInfo.area }}
          {{ personalInfo.address }}, {{ personalInfo.companyContact }},
          {{ personalInfo.phone }}
        </div>
      </template>
      <template v-if="checkInfo.deliveryType === '代发快递'">
        <div class="item_box">
          <div class="item_label nobg">快递公司：</div>
          <div class="item_content">
            <el-radio-group v-model="checkInfo.expressName" size="mini" @change="getPriceFun">
              <el-radio-button :label="item.expressName" v-for="(item, index) of expressList" :key="index">
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">省市区：</div>
          <div class="item_content">
            <el-cascader v-model="checkInfo.addressArray" :options="addressOptions" :props="{ expandTrigger: 'hover' }"
              class="input_box" style="width: 250px" size="mini" @change="changeAddressArray">
            </el-cascader>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">收货地址：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.address"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系人：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.contactName"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系电话：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.phone"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">快捷输入：</div>
          <div class="item_content">
            <el-input size="mini" type="textarea" v-model="checkInfo.textarea" style="width: 250px" placeholder="请输入地址">
            </el-input>
            <el-button type="primary" size="mini" class="ml12" @click="toCheckInfo">识别</el-button>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">优惠券：</div>
          <div class="item_content flex_center">
            <div v-if="!this.checkInfo.userCouponId" class="no_coupon">
              暂未可用优惠券
            </div>
            <div v-else class="use_coupon">
              <span style="color: #00a0e9">￥{{
                userCouponInfo.couponPrice
                  ? "-" + userCouponInfo.couponPrice
                  : ""
              }}</span>
              <!-- <span v-if="userCouponInfo.couponLimitprice">
                使用规则：{{ userCouponInfo.couponLimitprice }}
              </span> -->
            </div>
            <div class="my_coupon" @click="toMycoupon" v-if="userCouponList.length > 0">
              查看可用优惠券
            </div>
          </div>
        </div>
      </template>

      <div class="offer mb12">
        <div class="params">
          <span v-if="checkInfo.paperSizeHeight && checkInfo.paperSizeWeight">
            {{ checkInfo.paperSizeHeight }}x{{ checkInfo.paperSizeWeight }}mm
          </span>
          <span v-if="checkInfo.orderNum"> -{{ checkInfo.orderNum }}张 </span>
          <span v-if="cateConfig.categoryName">
            -{{ cateConfig.categoryName }}
          </span>
          <span v-if="checkInfo.productMode">
            -{{ checkInfo.productMode }}
          </span>
          <span v-if="checkInfo.specialProcess.length > 0">
            -
            <span v-for="(item, index) of checkInfo.specialProcess" :key="index">
              <span v-if="item === '烫金'">
                {{ item }}[{{ checkInfo.specialProcessBronzingLong }}x{{
                  checkInfo.specialProcessBronzingShort
                }}] {{ checkInfo.specialProcessBronzing }}_
              </span>
              <span v-else-if="item === '局部UV'">
                {{ item }}[{{ checkInfo.specialProcessUvLong }}x{{
                  checkInfo.specialProcessUvShort
                }}]_
              </span>
              <span v-else> {{ item }}_ </span>
            </span>
            {{ checkInfo.productMode }}
          </span>
          <span v-if="checkInfo.shipmentArrangement">
            -{{ checkInfo.shipmentArrangement }}
          </span>
          <span v-if="checkInfo.tectorial.tectorial"> -表面工艺{{ checkInfo.tectorial.tectorial }} </span>

          <el-tag type="success" style="cursor: pointer" @click="toCopyTwo" v-if="
            checkInfo.paperSizeHeight &&
            checkInfo.paperSizeWeight &&
            checkInfo.orderNum &&
            orderPrice
          ">复制报价总结</el-tag>
        </div>
        <div class="flex_between">
          <div class="flex_baseline price">
            <span v-if="orderPrice">价格:￥{{ orderPrice }}</span>
            <span v-else>价格:报价中...</span>
            <span v-if="userCouponInfo.userStatus">
              折扣：{{ userCouponInfo.couponPrice }}元
            </span>
            <span style="font-size: 14px; margin-left: 6px"
              v-if="freightPrice && checkInfo.deliveryType !== '上门自取'">运费：{{
              freightPrice }}元</span>
            <span style="font-size: 14px; margin-left: 6px" v-if="weight">预估重量：{{ weight }}kg</span>
          </div>
          <el-button size="small" style="color: 00a0e9; margin-right: 20px" @click="toQQ">
            <div class="btn">
              <img src="../../../assets/img/image.png" alt="" class="icon" />
              QQ交谈
            </div>
          </el-button>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">商标声明:</div>
        <div class="item_content font14px ml12">
          <el-checkbox v-model="agreeCheck"></el-checkbox>
          我同意
          <span class="agreement" @click="changeTab('6')">方和印刷版权声明</span>
          以及
          <span class="agreement" @click="changeTab('5')">知识产权要求规范</span>
        </div>
      </div>
      <div class="alret_box">
        <div class="alert mb12">
          <i class="el-icon-warning" style="margin-right: 6px; color: #faad14"></i>
          带有注册商标的说明书、合格证、产品标签、包装等订单，下单时请务必上传【品牌授权书或商标注册证书】，未提供的订单将被直接驳回，请及时关注
          我的订单-订单管理、微信消息通知，不再电话另行通知，尽情谅解！
        </div>
        <div class="tips font14px">
          告示：侵犯知识产权、色情、不法宗教、代开发票及其他违法内容均不可以下单至我司，如果发现客户下单上述违法印刷文件至本公司，客服因自动审稿没发现，导致印刷完成，我司将直接没收销毁，货款照样收取，请各位客户莫存侥幸心理，谢谢配合！
        </div>
      </div>
      <div class="flex_center_center mt40 mb100">
        <el-button class="pay_btn" style="margin-right: 250px" type="primary" @click="sureOrder"
          :disabled="!orderPrice">加入订单</el-button>
      </div>
    </div>
    <!-- 卷装不干胶 -->
    <div class="form_box" v-if="menuTitle === '卷装不干胶'">
      <div class="item_box">
        <div class="item_label required">材料名称</div>
        <div class="item_content">
          <div class="Materials_computer">
            <el-button v-for="(cate, cIndex) of categoryList" :key="cIndex" :class="[
              'radio_btn',
              cate.paperCategoryId === paperCategoryId ? 'active' : '',
            ]" @click="checkPaperCategory(cate)">
              {{ cate.categoryName }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">成品尺寸</div>
        <div class="item_content">
          <el-input size="mini" style="width: 80px" class="mb12" placeholder="长"
            v-model="checkInfo.paperSizeHeight"></el-input>
          X
          <el-input size="mini" style="width: 80px" class="mb12 mr12" placeholder="宽"
            v-model="checkInfo.paperSizeWeight"></el-input>
          <el-radio-group v-model="checkInfo.pageSize" @input="checkpageSize">
            <el-radio v-for="(item, index) of cateConfig.paperSize" :key="index" :label="item">
              {{ item }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">表面工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.tectorial" @input="checktectorial">
            <el-radio :label="item.tectorial" v-for="(item, index) in cateConfig.tectorialList" :key="index">{{ item.tectorial }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">其他工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.otherProcess" @input="checkOtherProcess">
            <el-radio :label="item.otherProcess" v-for="(item, index) in cateConfig.otherProcessList" :key="index">{{ item.otherProcess }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">成型工艺</div>
        <div class="item_content flex_center">
          <el-checkbox-group v-model="checkInfo.moldingProcess">
            <el-checkbox label="模切"></el-checkbox>
          </el-checkbox-group>
          <el-select placeholder="请选择" size="mini" style="width: 100px; margin-left: 4px"
            v-model="checkInfo.moldingProcessDieType" v-if="checkInfo.moldingProcess.includes('模切')">
            <el-option label="圆形" value="圆形"> </el-option>
            <el-option label="直角" value="直角"> </el-option>
            <el-option label="圆角" value="圆角"> </el-option>
            <el-option label="椭圆" value="椭圆"> </el-option>
            <el-option label="异形" value="异形"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">包装方式</div>
        <div class="item_content">
          <div class="flex_center">
            卷芯直径:
            <el-select placeholder="请选择" size="mini" style="width: 100px" v-model="checkInfo.packageCorediameter">
              <el-option label="75mm" value="75mm"> </el-option>
              <el-option label="40mm" value="40mm"> </el-option>
              <el-option label="30mm" value="30mm"> </el-option>
            </el-select>
            <el-tag type="success" size="mini" class="mr12 ml12" @click="toSeeShow('packageCorediameter')">示例</el-tag>
            出标方向:
            <el-select placeholder="请选择" size="mini" style="width: 100px" v-model="checkInfo.packageMarkingDirection">
              <el-option label="上出标" value="上出标"> </el-option>
              <el-option label="下出标" value="下出标"> </el-option>
              <el-option label="左出标" value="左出标"> </el-option>
              <el-option label="右出标" value="右出标"> </el-option>
            </el-select>
            <el-tag type="success" size="mini" class="mr12 ml12"
              @click="toSeeShow('packageMarkingDirection')">示例</el-tag>
            出标宽度:
            <el-select placeholder="请选择" size="mini" style="width: 100px" v-model="checkInfo.packageMarkingWeight">
              <el-option label="长边出标" value="长边出标"> </el-option>
              <el-option label="短边出标" value="短边出标"> </el-option>
            </el-select>
            <el-tag type="success" size="mini" class="mr12 ml12" @click="toSeeShow('packageMarkingWeight')">示例</el-tag>
          </div>
          <div class="mt12" v-if="checkInfo.packageMarkingWeight">
            <el-input placeholder="请输入" class="mr12" v-model="checkInfo.packageMarkingWeightPaper" size="mini"
              style="width: 300px">
              <template slot="prepend">每卷张数</template>
              <template slot="append">张/卷</template>
            </el-input>
            <el-input placeholder="请输入" v-model="checkInfo.packageMarkingWeightLength" size="mini" style="width: 300px">
              <template slot="prepend">每卷长度</template>
              <template slot="append">米/卷</template>
            </el-input>
            <span class="tip">温馨提示:每卷总长度请控制在350米以内，尽量取50整数，长度为预估尺寸。</span>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">印刷款数</div>
        <div class="item_content">
          <el-input-number v-model="checkInfo.printNum" controls-position="right" :min="1" size="mini"
            @change="changePrintNum"></el-input-number>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">成品总数</div>
        <div class="item_content flex">
          <div :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === item.quantity ? 'active_num' : '',
          ]" v-for="(item, index) of cateConfig.quantityPrice" :key="index" @click="checkOrderNum(item)">
            <div class="top_btn">{{ item.quantity }}</div>
            <div class="bottom_btn" v-if="item.orderPrice">
              ￥{{ item.orderPrice }}
            </div>
          </div>
          <div v-if="customizeObj.show" :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === customizeObj.quantity ? 'active_num' : '',
          ]" @click="checkOrderNum(customizeObj)">
            <div class="top_btn">{{ customizeObj.quantity }}</div>
            <div class="bottom_btn" v-if="customizeObj.orderPrice">
              ￥{{ customizeObj.orderPrice }}
            </div>
          </div>
          <div class="flex_center customize" style="height: 32px">
            自定义：
            <el-input-number style="width: 120px; height: 32px" size="small" class="mr12" :controls="false"
              v-model="customizeObj.orderNum" @change="changeOrderNum"></el-input-number>
            <el-button size="small" style="height: 32px" class="getPrice" @click="changeOrderNum">点击报价</el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label nobg">产品类型：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.productType">
            <el-radio label="宣传类不干胶">宣传类不干胶</el-radio>
            <el-radio label="商品类不干胶">商品类不干胶</el-radio>
            <el-radio label="无注册商标">无注册商标</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">配送方式：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.deliveryType" size="mini">
            <el-radio-button label="默认地址"></el-radio-button>
            <el-radio-button label="代发快递"></el-radio-button>
            <el-radio-button label="上门自取"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <template v-if="checkInfo.deliveryType === '默认地址'">
        <div class="address">
          {{ personalInfo.province }}
          {{ personalInfo.city }}
          {{ personalInfo.area }}
          {{ personalInfo.address }}, {{ personalInfo.companyContact }},
          {{ personalInfo.phone }}
        </div>
      </template>
      <template v-if="checkInfo.deliveryType === '代发快递'">
        <div class="item_box">
          <div class="item_label nobg">快递公司：</div>
          <div class="item_content">
            <el-radio-group v-model="checkInfo.expressName" size="mini" @change="getPriceFun">
              <el-radio-button :label="item.expressName" v-for="(item, index) of expressList" :key="index">
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">省市区：</div>
          <div class="item_content">
            <el-cascader v-model="checkInfo.addressArray" :options="addressOptions" :props="{ expandTrigger: 'hover' }"
              class="input_box" style="width: 250px" size="mini" @change="changeAddressArray">
            </el-cascader>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">收货地址：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.address"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系人：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.contactName"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系电话：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.phone"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">快捷输入：</div>
          <div class="item_content">
            <el-input size="mini" type="textarea" v-model="checkInfo.textarea" style="width: 250px" placeholder="请输入地址">
            </el-input>
            <el-button type="primary" size="mini" class="ml12" @click="toCheckInfo">识别</el-button>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">优惠券：</div>
          <div class="item_content flex_center">
            <div v-if="!this.checkInfo.userCouponId" class="no_coupon">
              暂未可用优惠券
            </div>
            <div v-else class="use_coupon">
              <span style="color: #00a0e9">￥{{
                userCouponInfo.couponPrice
                  ? "-" + userCouponInfo.couponPrice
                  : ""
              }}</span>
              <!-- <span v-if="userCouponInfo.couponLimitprice">
                使用规则：{{ userCouponInfo.couponLimitprice }}
              </span> -->
            </div>
            <div class="my_coupon" @click="toMycoupon" v-if="userCouponList.length > 0">
              查看可用优惠券
            </div>
          </div>
        </div>
      </template>

      <div class="offer mb12">
        <div class="params">
          <span v-if="checkInfo.paperSizeHeight && checkInfo.paperSizeWeight">
            {{ checkInfo.paperSizeHeight }}x{{ checkInfo.paperSizeWeight }}mm
          </span>
          <span v-if="checkInfo.orderNum"> -{{ checkInfo.orderNum }}张 </span>
          <span v-if="cateConfig.categoryName">
            -{{ cateConfig.categoryName }}
          </span>
          <span v-if="checkInfo.productMode">
            -{{ checkInfo.productMode }}{{ checkInfo.moldingProcessDieType }}
          </span>
          <span v-if="checkInfo.packageCorediameter">
            -卷芯直径{{ checkInfo.packageCorediameter }}-{{
              checkInfo.packageMarkingDirection
            }}-{{ checkInfo.packageMarkingWeight }}-每卷{{ checkInfo.packageMarkingWeightPaper }}张 -每卷{{
              checkInfo.packageMarkingWeightLength
            }}米 -
          </span>
          <span v-if="checkInfo.shipmentArrangement">
            -{{ checkInfo.shipmentArrangement }}
          </span>
          <span v-if="checkInfo.tectorial.tectorial"> -{{ checkInfo.tectorial.tectorial }} </span>

          <el-tag type="success" style="cursor: pointer" @click="toCopyThree" v-if="
            checkInfo.paperSizeHeight &&
            checkInfo.paperSizeWeight &&
            checkInfo.orderNum &&
            orderPrice
          ">复制报价总结</el-tag>
        </div>
        <div class="flex_between">
          <div class="flex_baseline price">
            <span v-if="orderPrice">价格:￥{{ orderPrice }}</span>
            <span v-else>价格:报价中...</span>
            <span v-if="userCouponInfo.userStatus">
              折扣：{{ userCouponInfo.couponPrice }}元
            </span>
            <span style="font-size: 14px; margin-left: 6px"
              v-if="freightPrice && checkInfo.deliveryType !== '上门自取'">运费：{{
              freightPrice }}元</span>
            <span style="font-size: 14px; margin-left: 6px" v-if="weight">预估重量：{{ weight }}kg</span>
          </div>
          <el-button size="small" style="color: 00a0e9; margin-right: 20px" @click="toQQ">
            <div class="btn">
              <img src="../../../assets/img/image.png" alt="" class="icon" />
              QQ交谈
            </div>
          </el-button>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">商标声明:</div>
        <div class="item_content font14px ml12">
          <el-checkbox v-model="agreeCheck"></el-checkbox>
          我同意
          <span class="agreement" @click="changeTab('6')">方和印刷版权声明</span>
          以及
          <span class="agreement" @click="changeTab('5')">知识产权要求规范</span>
        </div>
      </div>
      <div class="alret_box">
        <div class="alert mb12">
          <i class="el-icon-warning" style="margin-right: 6px; color: #faad14"></i>
          带有注册商标的说明书、合格证、产品标签、包装等订单，下单时请务必上传【品牌授权书或商标注册证书】，未提供的订单将被直接驳回，请及时关注
          我的订单-订单管理、微信消息通知，不再电话另行通知，尽情谅解！
        </div>
        <div class="tips font14px">
          告示：侵犯知识产权、色情、不法宗教、代开发票及其他违法内容均不可以下单至我司，如果发现客户下单上述违法印刷文件至本公司，客服因自动审稿没发现，导致印刷完成，我司将直接没收销毁，货款照样收取，请各位客户莫存侥幸心理，谢谢配合！
        </div>
      </div>
      <div class="flex_center_center mt40 mb100">
        <el-button class="pay_btn" style="margin-right: 250px" type="primary" @click="sureOrder"
          :disabled="!orderPrice">加入订单</el-button>
      </div>
    </div>
    <!-- 特殊卷标 -->
    <div class="form_box" v-if="menuTitle === '特殊卷标'">
      <div class="item_box">
        <div class="item_label required">材料名称</div>
        <div class="item_content">
          <div class="Materials_computer">
            <el-button v-for="(cate, cIndex) of categoryList" :key="cIndex" :class="[
              'radio_btn',
              cate.paperCategoryId === paperCategoryId ? 'active' : '',
            ]" @click="checkPaperCategory(cate)">
              {{ cate.categoryName }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">成品尺寸</div>
        <div class="item_content">
          <el-input size="mini" style="width: 80px" class="mb12" placeholder="长"
            v-model="checkInfo.paperSizeHeight"></el-input>
          X
          <el-input size="mini" style="width: 80px" class="mb12 mr12" placeholder="宽"
            v-model="checkInfo.paperSizeWeight"></el-input>
          <el-radio-group v-model="checkInfo.pageSize" @input="checkpageSize">
            <el-radio v-for="(item, index) of cateConfig.paperSize" :key="index" :label="item">
              {{ item }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">表面工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.tectorial" @input="checktectorial">
            <el-radio :label="item.tectorial" v-for="(item, index) in cateConfig.tectorialList" :key="index">{{ item.tectorial }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">其他工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.otherProcess" @input="checkOtherProcess">
            <el-radio :label="item.otherProcess" v-for="(item, index) in cateConfig.otherProcessList" :key="index">{{ item.otherProcess }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">成型工艺</div>
        <div class="item_content flex_center">
          <el-checkbox-group v-model="checkInfo.moldingProcess">
            <el-checkbox label="模切"></el-checkbox>
          </el-checkbox-group>
          <el-select placeholder="请选择" size="mini" style="width: 100px; margin-left: 4px"
            v-model="checkInfo.moldingProcessDieType" v-if="checkInfo.moldingProcess.includes('模切')">
            <el-option label="圆形" value="圆形"> </el-option>
            <el-option label="直角" value="直角"> </el-option>
            <el-option label="圆角" value="圆角"> </el-option>
            <el-option label="椭圆" value="椭圆"> </el-option>
            <el-option label="异形" value="异形"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">包装方式</div>
        <div class="item_content">
          <div class="flex_center">
            卷芯直径:
            <el-select placeholder="请选择" size="mini" style="width: 100px" v-model="checkInfo.packageCorediameter">
              <el-option label="75mm" value="75mm"> </el-option>
              <el-option label="40mm" value="40mm"> </el-option>
              <el-option label="30mm" value="30mm"> </el-option>
            </el-select>
            <el-tag type="success" size="mini" class="mr12 ml12" @click="toSeeShow('packageCorediameter')">示例</el-tag>
            出标方向:
            <el-select placeholder="请选择" size="mini" style="width: 100px" v-model="checkInfo.packageMarkingDirection">
              <el-option label="上出标" value="上出标"> </el-option>
              <el-option label="下出标" value="下出标"> </el-option>
              <el-option label="左出标" value="左出标"> </el-option>
              <el-option label="右出标" value="右出标"> </el-option>
            </el-select>
            <el-tag type="success" size="mini" class="mr12 ml12"
              @click="toSeeShow('packageMarkingDirection')">示例</el-tag>
            出标宽度:
            <el-select placeholder="请选择" size="mini" style="width: 100px" v-model="checkInfo.packageMarkingWeight">
              <el-option label="长边出标" value="长边出标"> </el-option>
              <el-option label="短边出标" value="短边出标"> </el-option>
            </el-select>
            <el-tag type="success" size="mini" class="mr12 ml12" @click="toSeeShow('packageMarkingWeight')">示例</el-tag>
          </div>
          <div class="mt12" v-if="checkInfo.packageMarkingWeight">
            <el-input placeholder="请输入" class="mr12" v-model="checkInfo.packageMarkingWeightPaper" size="mini"
              style="width: 300px">
              <template slot="prepend">每卷张数</template>
              <template slot="append">张/卷</template>
            </el-input>
            <el-input placeholder="请输入" v-model="checkInfo.packageMarkingWeightLength" size="mini" style="width: 300px">
              <template slot="prepend">每卷长度</template>
              <template slot="append">米/卷</template>
            </el-input>
            <span class="tip">温馨提示:每卷总长度请控制在350米以内，尽量取50整数，长度为预估尺寸。</span>
          </div>
        </div>
      </div>

      <div class="item_box">
        <div class="item_label required">印刷款数</div>
        <div class="item_content">
          <el-input-number v-model="checkInfo.printNum" controls-position="right" :min="1" size="mini"
            @change="changePrintNum"></el-input-number>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">成品总数</div>
        <div class="item_content flex">
          <div :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === item.quantity ? 'active_num' : '',
          ]" v-for="(item, index) of cateConfig.quantityPrice" :key="index" @click="checkOrderNum(item)">
            <div class="top_btn">{{ item.quantity }}</div>
            <div class="bottom_btn" v-if="item.orderPrice">
              ￥{{ item.orderPrice }}
            </div>
          </div>
          <div v-if="customizeObj.show" :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === customizeObj.quantity ? 'active_num' : '',
          ]" @click="checkOrderNum(customizeObj)">
            <div class="top_btn">{{ customizeObj.quantity }}</div>
            <div class="bottom_btn" v-if="customizeObj.orderPrice">
              ￥{{ customizeObj.orderPrice }}
            </div>
          </div>
          <div class="flex_center customize" style="height: 32px">
            自定义：
            <el-input-number style="width: 120px; height: 32px" size="small" class="mr12" :controls="false"
              v-model="customizeObj.orderNum" @change="changeOrderNum"></el-input-number>
            <el-button size="small" style="height: 32px" class="getPrice" @click="changeOrderNum">点击报价</el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label nobg">产品类型：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.productType">
            <el-radio label="宣传类不干胶">宣传类不干胶</el-radio>
            <el-radio label="商品类不干胶">商品类不干胶</el-radio>
            <el-radio label="无注册商标">无注册商标</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">配送方式：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.deliveryType" size="mini">
            <el-radio-button label="默认地址"></el-radio-button>
            <el-radio-button label="代发快递"></el-radio-button>
            <el-radio-button label="上门自取"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <template v-if="checkInfo.deliveryType === '默认地址'">
        <div class="address">
          {{ personalInfo.province }}
          {{ personalInfo.city }}
          {{ personalInfo.area }}
          {{ personalInfo.address }}, {{ personalInfo.companyContact }},
          {{ personalInfo.phone }}
        </div>
      </template>
      <template v-if="checkInfo.deliveryType === '代发快递'">
        <div class="item_box">
          <div class="item_label nobg">快递公司：</div>
          <div class="item_content">
            <el-radio-group v-model="checkInfo.expressName" size="mini" @change="getPriceFun">
              <el-radio-button :label="item.expressName" v-for="(item, index) of expressList" :key="index">
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">省市区：</div>
          <div class="item_content">
            <el-cascader v-model="checkInfo.addressArray" :options="addressOptions" :props="{ expandTrigger: 'hover' }"
              class="input_box" style="width: 250px" size="mini" @change="changeAddressArray">
            </el-cascader>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">收货地址：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.address"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系人：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.contactName"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系电话：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.phone"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">快捷输入：</div>
          <div class="item_content">
            <el-input size="mini" type="textarea" v-model="checkInfo.textarea" style="width: 250px" placeholder="请输入地址">
            </el-input>
            <el-button type="primary" size="mini" class="ml12" @click="toCheckInfo">识别</el-button>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">优惠券：</div>
          <div class="item_content flex_center">
            <div v-if="!this.checkInfo.userCouponId" class="no_coupon">
              暂未可用优惠券
            </div>
            <div v-else class="use_coupon">
              <span style="color: #00a0e9">￥{{
                userCouponInfo.couponPrice
                  ? "-" + userCouponInfo.couponPrice
                  : ""
              }}</span>
              <!-- <span v-if="userCouponInfo.couponLimitprice">
                使用规则：{{ userCouponInfo.couponLimitprice }}
              </span> -->
            </div>
            <div class="my_coupon" @click="toMycoupon" v-if="userCouponList.length > 0">
              查看可用优惠券
            </div>
          </div>
        </div>
      </template>

      <div class="offer mb12">
        <div class="params">
          <span v-if="checkInfo.paperSizeHeight && checkInfo.paperSizeWeight">
            {{ checkInfo.paperSizeHeight }}x{{ checkInfo.paperSizeWeight }}mm
          </span>
          <span v-if="checkInfo.orderNum"> -{{ checkInfo.orderNum }}张 </span>
          <span v-if="cateConfig.categoryName">
            -{{ cateConfig.categoryName }}
          </span>
          <span v-if="checkInfo.productMode">
            -{{ checkInfo.productMode }}{{ checkInfo.moldingProcessDieType }}
          </span>
          <span v-if="checkInfo.packageCorediameter">
            -卷芯直径{{ checkInfo.packageCorediameter }}-{{
              checkInfo.packageMarkingDirection
            }}-{{ checkInfo.packageMarkingWeight }}-每卷{{ checkInfo.packageMarkingWeightPaper }}张 -每卷{{
              checkInfo.packageMarkingWeightLength
            }}米 -
          </span>
          <span v-if="checkInfo.shipmentArrangement">
            -{{ checkInfo.shipmentArrangement }}
          </span>
          <span v-if="checkInfo.tectorial.tectorial"> -{{ checkInfo.tectorial.tectorial }} </span>

          <el-tag type="success" style="cursor: pointer" @click="toCopyFour" v-if="
            checkInfo.paperSizeHeight &&
            checkInfo.paperSizeWeight &&
            checkInfo.orderNum &&
            orderPrice
          ">复制报价总结</el-tag>
        </div>
        <div class="flex_between">
          <div class="flex_baseline price">
            <span v-if="orderPrice">价格:￥{{ orderPrice }}</span>
            <span v-else>价格:报价中...</span>
            <span v-if="userCouponInfo.userStatus">
              折扣：{{ userCouponInfo.couponPrice }}元
            </span>
            <span style="font-size: 14px; margin-left: 6px"
              v-if="freightPrice && checkInfo.deliveryType !== '上门自取'">运费：{{
              freightPrice }}元</span>
            <span style="font-size: 14px; margin-left: 6px" v-if="weight">预估重量：{{ weight }}kg</span>
          </div>
          <el-button size="small" style="color: 00a0e9; margin-right: 20px" @click="toQQ">
            <div class="btn">
              <img src="../../../assets/img/image.png" alt="" class="icon" />
              QQ交谈
            </div>
          </el-button>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">商标声明:</div>
        <div class="item_content font14px ml12">
          <el-checkbox v-model="agreeCheck"></el-checkbox>
          我同意
          <span class="agreement" @click="changeTab('6')">方和印刷版权声明</span>
          以及
          <span class="agreement" @click="changeTab('5')">知识产权要求规范</span>
        </div>
      </div>
      <div class="alret_box">
        <div class="alert mb12">
          <i class="el-icon-warning" style="margin-right: 6px; color: #faad14"></i>
          带有注册商标的说明书、合格证、产品标签、包装等订单，下单时请务必上传【品牌授权书或商标注册证书】，未提供的订单将被直接驳回，请及时关注
          我的订单-订单管理、微信消息通知，不再电话另行通知，尽情谅解！
        </div>
        <div class="tips font14px">
          告示：侵犯知识产权、色情、不法宗教、代开发票及其他违法内容均不可以下单至我司，如果发现客户下单上述违法印刷文件至本公司，客服因自动审稿没发现，导致印刷完成，我司将直接没收销毁，货款照样收取，请各位客户莫存侥幸心理，谢谢配合！
        </div>
      </div>
      <div class="flex_center_center mt40 mb100">
        <el-button class="pay_btn" style="margin-right: 250px" type="primary" @click="sureOrder"
          :disabled="!orderPrice">加入订单</el-button>
      </div>
    </div>
    <!-- 数码不干胶 -->
    <div class="form_box" v-if="menuTitle === '数码不干胶'">
      <div class="item_box">
        <div class="item_label required">材料名称</div>
        <div class="item_content">
          <div class="Materials_computer">
            <el-button v-for="(cate, cIndex) of categoryList" :key="cIndex" :class="[
              'radio_btn',
              cate.paperCategoryId === paperCategoryId ? 'active' : '',
            ]" @click="checkPaperCategory(cate)">
              {{ cate.categoryName }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">成品尺寸</div>
        <div class="item_content">
          <el-input size="mini" style="width: 80px" class="mb12" placeholder="长"
            v-model="checkInfo.paperSizeHeight"></el-input>
          X
          <el-input size="mini" style="width: 80px" class="mb12 mr12" placeholder="宽"
            v-model="checkInfo.paperSizeWeight"></el-input>
          <el-radio-group v-model="checkInfo.pageSize" @input="checkpageSize">
            <el-radio v-for="(item, index) of cateConfig.paperSize" :key="index" :label="item">
              {{ item }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">印面</div>
        <div class="item_content">
          <el-radio v-model="checkInfo.printingSurface" label="彩色单面">彩色单面</el-radio>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">印刷款数</div>
        <div class="item_content">
          <el-input-number v-model="checkInfo.printNum" controls-position="right" :min="1" size="mini"
            @change="changePrintNum"></el-input-number>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label required">表面工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.tectorial" @input="checktectorial">
            <el-radio :label="item.tectorial" v-for="(item, index) in cateConfig.tectorialList" :key="index">{{ item.tectorial }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">其他工艺</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.otherProcess" @input="checkOtherProcess">
            <el-radio :label="item.otherProcess" v-for="(item, index) in cateConfig.otherProcessList" :key="index">{{ item.otherProcess }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">成型类型</div>
        <div class="item_content">
          <el-radio v-model="checkInfo.moldingType" label="切成品">切成品</el-radio>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">包装方式</div>
        <div class="item_content">
          <el-radio v-model="checkInfo.packageType" label="标准包">标准包</el-radio>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">成品数量</div>
        <div class="item_content flex">
          <div :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === item.quantity ? 'active_num' : '',
          ]" v-for="(item, index) of cateConfig.quantityPrice" :key="index" @click="checkOrderNum(item)">
            <div class="top_btn">{{ item.quantity }}</div>
            <div class="bottom_btn" v-if="item.orderPrice">
              ￥{{ item.orderPrice }}
            </div>
          </div>
          <div v-if="customizeObj.show" :class="[
            'product_num_btn pointer',
            checkInfo.orderNum === customizeObj.quantity ? 'active_num' : '',
          ]" @click="checkOrderNum(customizeObj)">
            <div class="top_btn">{{ customizeObj.quantity }}</div>
            <div class="bottom_btn" v-if="customizeObj.orderPrice">
              ￥{{ customizeObj.orderPrice }}
            </div>
          </div>
          <div class="flex_center customize" style="height: 32px">
            自定义：
            <el-input-number style="width: 120px; height: 32px" size="small" class="mr12" :controls="false"
              v-model="customizeObj.orderNum" @change="changeOrderNum"></el-input-number>
            <el-button size="small" style="height: 32px" class="getPrice" @click="changeOrderNum">点击报价</el-button>
          </div>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label nobg">产品类型：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.productType">
            <el-radio label="宣传类不干胶">宣传类不干胶</el-radio>
            <el-radio label="商品类不干胶">商品类不干胶</el-radio>
            <el-radio label="无注册商标">无注册商标</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">配送方式：</div>
        <div class="item_content">
          <el-radio-group v-model="checkInfo.deliveryType" size="mini">
            <el-radio-button label="默认地址"></el-radio-button>
            <el-radio-button label="代发快递"></el-radio-button>
            <el-radio-button label="上门自取"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <template v-if="checkInfo.deliveryType === '默认地址'">
        <div class="address">
          {{ personalInfo.province }}
          {{ personalInfo.city }}
          {{ personalInfo.area }}
          {{ personalInfo.address }}, {{ personalInfo.companyContact }},
          {{ personalInfo.phone }}
        </div>
      </template>
      <template v-if="checkInfo.deliveryType === '代发快递'">
        <div class="item_box">
          <div class="item_label nobg">快递公司：</div>
          <div class="item_content">
            <el-radio-group v-model="checkInfo.expressName" size="mini" @change="getPriceFun">
              <el-radio-button :label="item.expressName" v-for="(item, index) of expressList" :key="index">
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">省市区：</div>
          <div class="item_content">
            <el-cascader v-model="checkInfo.addressArray" :options="addressOptions" :props="{ expandTrigger: 'hover' }"
              class="input_box" style="width: 250px" size="mini" @change="changeAddressArray">
            </el-cascader>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">收货地址：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.address"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系人：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.contactName"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">联系电话：</div>
          <div class="item_content">
            <el-input size="mini" style="width: 250px" v-model="checkInfo.phone"></el-input>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">快捷输入：</div>
          <div class="item_content">
            <el-input size="mini" type="textarea" v-model="checkInfo.textarea" style="width: 250px" placeholder="请输入地址">
            </el-input>
            <el-button type="primary" size="mini" class="ml12" @click="toCheckInfo">识别</el-button>
          </div>
        </div>
        <div class="item_box">
          <div class="item_label nobg">优惠券：</div>
          <div class="item_content flex_center">
            <div v-if="!this.checkInfo.userCouponId" class="no_coupon">
              暂未可用优惠券
            </div>
            <div v-else class="use_coupon">
              <span style="color: #00a0e9">￥{{
                userCouponInfo.couponPrice
                  ? "-" + userCouponInfo.couponPrice
                  : ""
              }}</span>
              <!-- <span v-if="userCouponInfo.couponLimitprice">
                使用规则：{{ userCouponInfo.couponLimitprice }}
              </span> -->
            </div>
            <div class="my_coupon" @click="toMycoupon" v-if="userCouponList.length > 0">
              查看可用优惠券
            </div>
          </div>
        </div>
      </template>

      <div class="offer mb12">
        <div class="params">
          <span v-if="checkInfo.paperSizeHeight && checkInfo.paperSizeWeight">
            {{ checkInfo.paperSizeHeight }}x{{ checkInfo.paperSizeWeight }}mm
          </span>
          <span v-if="checkInfo.orderNum"> -{{ checkInfo.orderNum }}张 </span>
          <span v-if="cateConfig.categoryName">
            -{{ cateConfig.categoryName }}
          </span>
          <span v-if="checkInfo.printingSurface">
            -印面{{ checkInfo.printingSurface }}
          </span>
          <span v-if="checkInfo.moldingType">-成型类型:{{ checkInfo.moldingType }}</span>
          <span v-if="checkInfo.packageType">-包装方式:{{ checkInfo.packageType }}</span>
          <span v-if="checkInfo.shipmentArrangement">
            -{{ checkInfo.shipmentArrangement }}
          </span>
          <span v-if="checkInfo.tectorial"> -{{ checkInfo.tectorial.tectorial }} </span>
          <span v-if="checkInfo.printNum">-{{ checkInfo.printNum }}张</span>

          <el-tag type="success" style="cursor: pointer" @click="toCopyFive" v-if="
            checkInfo.paperSizeHeight &&
            checkInfo.paperSizeWeight &&
            checkInfo.orderNum &&
            orderPrice
          ">复制报价总结</el-tag>
        </div>
        <div class="flex_between">
          <div class="flex_baseline price">
            <span v-if="orderPrice">价格:￥{{ orderPrice }}</span>
            <span v-else>价格:报价中...</span>
            <span v-if="userCouponInfo.userStatus">
              折扣：{{ userCouponInfo.couponPrice }}元
            </span>
            <span style="font-size: 14px; margin-left: 6px"
              v-if="freightPrice && checkInfo.deliveryType !== '上门自取'">运费：{{
              freightPrice }}元</span>
            <span style="font-size: 14px; margin-left: 6px" v-if="weight">预估重量：{{ weight }}kg</span>
          </div>
          <el-button size="small" style="color: 00a0e9; margin-right: 20px" @click="toQQ">
            <div class="btn">
              <img src="../../../assets/img/image.png" alt="" class="icon" />
              QQ交谈
            </div>
          </el-button>
        </div>
      </div>
      <div class="item_box">
        <div class="item_label">商标声明:</div>
        <div class="item_content font14px ml12">
          <el-checkbox v-model="agreeCheck"></el-checkbox>
          我同意
          <span class="agreement" @click="changeTab('6')">方和印刷版权声明</span>
          以及
          <span class="agreement" @click="changeTab('5')">知识产权要求规范</span>
        </div>
      </div>
      <div class="alret_box">
        <div class="alert mb12">
          <i class="el-icon-warning" style="margin-right: 6px; color: #faad14"></i>
          带有注册商标的说明书、合格证、产品标签、包装等订单，下单时请务必上传【品牌授权书或商标注册证书】，未提供的订单将被直接驳回，请及时关注
          我的订单-订单管理、微信消息通知，不再电话另行通知，尽情谅解！
        </div>
        <div class="tips font14px">
          告示：侵犯知识产权、色情、不法宗教、代开发票及其他违法内容均不可以下单至我司，如果发现客户下单上述违法印刷文件至本公司，客服因自动审稿没发现，导致印刷完成，我司将直接没收销毁，货款照样收取，请各位客户莫存侥幸心理，谢谢配合！
        </div>
      </div>
      <div class="flex_center_center mt40 mb100">
        <el-button class="pay_btn" style="margin-right: 250px" type="primary" @click="sureOrder"
          :disabled="!orderPrice">加入订单</el-button>
      </div>
    </div>

    <!-- 查看说明 -->
    <el-dialog :title="tipsModel.title" :visible.sync="tipsModel.flag" width="60%">
      <div>
        <img src="../img/tushi.jpg" alt="" style="width: 100%" v-if="tipsModel.type === 'shipmentArrangement'" />
        <img src="../img/tushi1.jpg" alt="" style="width: 100%" v-if="tipsModel.type === 'cutType'" />
        <img src="../img/tushi2.jpg" alt="" style="width: 100%" v-if="tipsModel.type === 'packageCorediameter'" />
        <img src="../img/tushi3.jpg" alt="" style="width: 100%" v-if="tipsModel.type === 'packageMarkingDirection'" />
        <img src="../img/tushi4.png" alt="" style="width: 100%" v-if="tipsModel.type === 'packageMarkingWeight'" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipsModel.flag = false">取 消</el-button>
        <el-button type="primary" @click="tipsModel.flag = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 文件上传 -->
    <el-dialog :title="fileModel.title" :visible.sync="fileModel.flag" width="700px">
      <div>
        <el-form ref="form" :model="fileModel" label-width="100px" :rules="fileRules">
          <el-form-item label="印刷文件" prop="fileUrl">
            <div class="upload_box" v-if="!fileModel.fileUrl">
              <input type="file" accept="image/" @change="handleUpdataFile" />
              <i class="el-icon-box upload_icon"></i>
              <span class="bold">点击或拖拽文件至此处上传</span>
              <span>可印刷的矢量文件，如：Adobe Illustrator、CDR、PDF</span>
            </div>
            <div v-else style="display: flex;">
              <!-- <el-image style="width: 100px; height: 100px" :src="fileModel.fileUrl"
                :preview-src-list="[fileModel.fileUrl]">
              </el-image> -->
              <div>{{fileModel.fileName}}</div>
              <el-button type="text" style="color: red" class="ml12" @click="deleteFile">删除</el-button>
            </div>
            <div class="tips">
              温馨提示：请点击添加你要印刷的文件， 一次只能上传 1
              个文件，大小≤500MB。
            </div>
          </el-form-item>
          <!-- <el-form-item label="支付方式" prop="payType">
            <el-radio-group v-model="fileModel.payType">
              <el-radio label="PRE_STORAGE" :disabled="Number(orderTotalPrice) > Number(personalInfo.balance)
                  ? true
                  : false
                ">
                预存款支付
                <span class="ml12">余额：{{
                  personalInfo.balance ? personalInfo.balance : 0
                }}</span>
              </el-radio>
            </el-radio-group>
            <el-button v-if="orderTotalPrice > personalInfo.balance" type="primary" size="mini" class="ml12"
              @click="toRecharge">去充值</el-button>
          </el-form-item> -->
          <el-form-item label="品牌授权书或商标注册证书" prop="authenticationUrl1">
            <div class="flex">
              <el-select v-model="fileModel.authenticationId1" placeholder="选择已有品牌授权书或商标注册证书" style="flex: 1"
                class="mr12" @change="changeAuthenticationId1">
                <el-option v-for="item in authenticationId1List" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-button type="primary" style="width: 80px" class="btn_style" @click="getauthenList">刷新</el-button>
              <el-button type="primary" style="width: 80px" class="btn_style" @click="toUpload('1')">上传</el-button>
            </div>
          </el-form-item>
          <el-form-item label="委印许可证明" prop="authenticationUrl2">
            <div class="flex">
              <el-select v-model="fileModel.authenticationId2" placeholder="选择已有委印许可证明" style="flex: 1" class="mr12"
                @change="changeAuthenticationId2">
                <el-option v-for="item in authenticationId2List" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-button type="primary" style="width: 80px" class="btn_style" @click="getauthenList">刷新</el-button>
              <el-button type="primary" style="width: 80px" class="btn_style" @click="toUpload('2')">上传</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fileModel.flag = false">取 消</el-button>
        <el-button type="primary" @click="addCustomOrder" :disabled="!orderPrice">开始上传</el-button>
      </span>
    </el-dialog>

    <!-- 扫码支付 -->
    <wechat-pay-dialog ref="wechatPayDialog" :visible.sync="payModel.flag" :title="payModel.title"
      :wx-url="payModel.wxUrl" :order-no="payModel.orderNo" @pay-success="handlePaySuccess"></wechat-pay-dialog>

    <!-- 上传证书 -->
    <el-dialog title="授权书上传" :visible.sync="addModel.flag" width="520">
      <div>
        <el-form ref="ruleForm" :model="addModel" label-width="100px" :rules="rules">
          <el-form-item label="证书名称" prop="authenticationTitle">
            <el-input v-model="addModel.authenticationTitle" placeholder="请输入证书名称"></el-input>
          </el-form-item>
          <el-form-item label="有效期" prop="authenticationExpirTime">
            <el-date-picker v-model="addModel.authenticationExpirTime" type="date" placeholder="选择日期有效期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="证书类型" prop="authenticationType">
            <el-radio-group v-model="addModel.authenticationType">
              <el-radio label="BRAND">品牌授权书</el-radio>
              <el-radio label="TRADE_MARK">商标注册书</el-radio>
              <el-radio label="PROXY">承印委托书</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="证书文件" prop="authenticationUrl">
            <div class="upload_box" v-if="!addModel.authenticationUrl">
              <input type="file" accept="image/" @change="authenticationUrlFile" />
              <i class="el-icon-box upload_icon"></i>
              <span class="bold">点击或拖拽文件至此处上传</span>
              <span>.pdf,.jpg,.jpeg,.png,.PDF,.JPG,.JPEG,.PNG</span>
            </div>
            <div v-else>
              {{ addModel.fileName }}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModel.flag = false">取 消</el-button>
        <el-button class="btn_style" type="primary" @click="sureAdd">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="couponModel.title" :visible.sync="couponModel.flag" width="30%">
      <div style="height: 400px; overflow-y: auto">
        <el-card v-for="(item, index) of userCouponList" :key="index" class="mb12">
          <div slot="header" class="clearfix">
            <span>{{ item.couponPrice }}元</span>
            <el-button style="float: right; padding: 3px 0" type="text"
              v-if="checkInfo.userCouponId !== item.userCouponId" @click="toUseCoupon(item)">使用</el-button>
            <el-button style="float: right; padding: 3px 0" type="text" disabled
              v-if="checkInfo.userCouponId === item.userCouponId">已选择</el-button>
          </div>
          满{{ item.couponLimitprice }}可用 失效时间: {{ item.endTime }}
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="couponModel.flag = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import china from "../../../assets/json/pcas-code.json";
import {
  categoryListApi,
  categoryDetailApi,
  orderPriceApi,
  sureOrderApi,
  expressListApi,
  getOssAuth,
  getSettingApi,
  personalInfoApi,
  authenticationAddApi,
  authenticationListApi,
  myCouponListApi,
  getCustomerServiceApi,
  batchOrderApi,
  wechatQrCodeApi,
} from "../../../api/index";
import smart from "address-smart-parse";
import WechatPayDialog from "./WechatPayDialog.vue";
export default {
  name: "orderForm",
  components: {
    WechatPayDialog,
  },
  props: {
    paperType: {
      type: String,
      default: "3",
    },
    menuTitle: {
      type: String,
      default: "卷装不干胶",
    },
  },
  data() {
    return {
      topInfo: {
        show: true,
        customerName: "",
        orderQQ: "",
        businessName: "",
        businessPhone: "",
        productOwnerTitle: "",
        productOwnerWxUrl: "",
        complaintPhone: "",
        productOwnerTel:"",
        workTime:""
      },
      parentId: "1",
      paperCategoryId: "",
      categoryList: [],
      cateConfig: {
        categoryName: "",
        paperSize: [],
        shipmentArrangement: [],
        tectorial: [],
        otherProcess: [],
        paperNum: [],
        tectorialList: [],
        otherProcessList: [],
        quantityPrice: [],
      },
      checkInfo: {
        pageSize: "",
        paperSizeWeight: "",
        paperSizeHeight: "",
        shipmentArrangement: "",
        shipmentArrangementLongSide: "",
        shipmentArrangementShortSide: "",
        cutType: "随文件", // 模切类型
        tectorial: "",
        otherProcess: "",
        printNum: 0,
        orderNum: 0,
        productType: "宣传类不干胶",
        deliveryType: "代发快递",
        expressName: "平安达",
        userCouponId: "",
        addressArray: [],
        address: "",
        province: "",
        city: "",
        area: "",
        street: "",
        contactName: "",
        phone: "",
        textarea: "",
        productMode: "",
        specialProcess: [],
        specialProcessBronzing: "",
        specialProcessBronzingLong: "",
        specialProcessBronzingShort: "",
        specialProcessUvLong: "",
        specialProcessUvShort: "",
        moldingProcess: [],
        moldingProcessDieType: "",
        packageCorediameter: "",
        packageMarkingDirection: "",
        packageMarkingWeight: "",
        packageMarkingWeightPaper: "",
        packageMarkingWeightLength: "",
        moldingType: "",
        packageType: "",
        printingSurface: "",
      },
      orderPrice: 0, // 订单金额
      orderTotalPrice: 0, //总金额
      weight: "", // 预估重量
      freightPrice: "", //快递
      agreeCheck: false,
      // 查看说明弹窗
      tipsModel: {
        flag: false,
        title: "",
        type: "",
      },
      cutTypeOptions: [
        {
          value: "随文件",
          label: "随文件",
        },
        {
          value: "圆形",
          label: "圆形",
        },
        {
          value: "直角",
          label: "直角",
        },
        {
          value: "圆角",
          label: "圆角",
        },
        {
          value: "椭圆",
          label: "椭圆",
        },
        {
          value: "异形",
          label: "异形",
        },
      ],
      expressList: [],
      fileModel: {
        flag: false,
        title: "文件上传",
        fileName: "",
        fileUrl: "",
        payType: "PRE_STORAGE",
        authenticationId1: '',
        authenticationFileSuffix1: "",
        authenticationUrl1: "",
        authenticationId2: '',
        authenticationFileSuffix2: "",
        authenticationUrl2: "",
        onOk: () => { },
      },
      fileRules: {
        fileUrl: [
          { required: true, message: "请上传印刷文件", trigger: "blur" },
        ],
      },
      rules: {
        fileUrl: [
          { required: true, message: "请上传印刷文件", trigger: "blur" },
        ],
      },
      authenticationId1List: [],
      authenticationId2List: [],
      // 扫码支付弹窗
      payModel: {
        flag: false,
        title: "",
        orderId: "",
        orderNo: "",
        payStatus: false,
        wxUrl: "",
      },
      // 优惠券内容
      userCouponInfo: {},
      userCouponList: [],
      // 会员信息
      personalInfo: {
        userId: 1,
        companyName: "",
        companyContact: "",
        phone: "",
        telephone: "",
        qq: "",
        email: "",
        province: "",
        city: "",
        area: "",
        address: "",
        certificationType: "PERSONAL",
        certificationCompanyName: "",
        certificationCompanyCode: "",
        certificationCompanyLicense: "",
        certificationPersonName: "",
        certificationIdCard: "",
        certificationPersonIdCardFront: "",
        certificationPersonIdCardBack: "",
        certificationStatus: "",
        bankName: "",
        bankCard: "",
        companyAddress: "",
        bankPhone: "",
        billingType: "",
        balance: 0,
      },
      // 上传证书
      addModel: {
        flag: false,
        authenticationId: 0,
        authenticationTitle: "11",
        authenticationExpirTime: "2025-11-11",
        authenticationType: "BRAND",
        authenticationFileSuffix: "",
        authenticationUrl: "",
        fileName: "",
        suffix: "",
      },
      rules: {
        authenticationTitle: [
          { required: true, message: "请输入证书名称", trigger: "blur" },
        ],
        authenticationExpirTime: [
          { required: true, message: "请选择日期有效期", trigger: "blur" },
        ],
        authenticationTitle: [
          { required: true, message: "请输入证书名称", trigger: "blur" },
        ],
      },
      // 自定义数量 价格
      customizeObj: {
        show: false,
        orderNum: 0,
        price: 0,
        quantity: 0,
      },
      // 优惠券弹窗
      couponModel: {
        flag: false,
        title: "可用优惠券",
      },

      checked: false,
      checked1: false,
      checked2: false,
      radio: "1",
      radio1: "上海",
      radio2: "1",
      radio3: "1",
      radio4: "1",
      radio5: "代发快递",
      radio6: "中通",
      selectType: "选项1",
      address: [],
      addressOptions: [],
      num: 1,

      date: "2025-03-14",
      address: [],
      checkList: [],
      colorList: [
        {
          value: "亮黄金",
          label: "亮黄金",
        },
        {
          value: "哑黄金",
          label: "哑黄金",
        },
        {
          value: "黑金",
          label: "黑金",
        },
        {
          value: "红金",
          label: "红金",
        },
        {
          value: "蓝金",
          label: "蓝金",
        },
        {
          value: "绿金",
          label: "绿金",
        },
        {
          value: "紫金",
          label: "紫金",
        },
        {
          value: "镭射金",
          label: "镭射金",
        },
        {
          value: "镭射银",
          label: "镭射银",
        },
        {
          value: "银色",
          label: "银色",
        },
      ],
      selectColor: "",
      checkList2: [],
      checkList3: [],
      // 自命名下单相关
      customOrderVisible: true,
      customOrders: [],
      customOrderCollapsed: true, // 控制组件是否收缩
      customOrderListVisible: false,
      customOrderTotalPrice: 0,
    };
  },
  created() {
    const address = china.map((province) => {
      const citys = province.children.map((f) => {
        const district = f.children.map((item) => {
          return {
            name: item.name,
            code: item.code,
            value: item.name,
            label: item.name,
          };
        });
        return {
          name: f.name,
          code: f.code,
          children: district,
          value: f.name,
          label: f.name,
        };
      });
      return {
        name: province.name,
        code: province.code,
        value: province.name,
        label: province.name,
        children: citys,
      };
    });
    this.addressOptions = address;
    
    // 从localStorage加载订单数据
    const savedOrders = localStorage.getItem('customOrders');
    if (savedOrders) {
      this.customOrders = JSON.parse(savedOrders);
      this.updateCustomOrderTotal();
    }
  },
  activated() {
    this.getcategory();
    this.getExpressNameList();
  },
  mounted() {
    this.getSetting();
  },
  methods: {
    // 扫码支付成功（支付弹窗自动关闭）后清空自命名下单列表
    handlePaySuccess() {
      this.customOrders = [];
      this.updateCustomOrderTotal();
    },
    // 重置
    resetForm() {
      this.categoryList= [];
      this.cateConfig= {
        categoryName: "",
        paperSize: [],
        shipmentArrangement: [],
        tectorial: [],
        otherProcess: [],
        paperNum: [],
        tectorialList: [],
        otherProcessList: [],
        quantityPrice: [],
      }
    },

    getSetting() {
      getCustomerServiceApi(this.$store.state.userInfo.userId).then((res) => {
        if (res.resultStatus) {
          const result = res.resultData;
          this.topInfo.show = true;
          for(let key in result){
            this.topInfo[key] = result[key]?result[key]:"";
          }
        } else {
          this.topInfo.show = false;
        }
      });
    },
    getUserInfo() {
      personalInfoApi()
        .then((res) => {
          if (res.resultStatus) {
            const result = res.resultData;
            this.personalInfo = { ...res.resultData };
            for(let key in result){
                this.checkInfo[key] = result[key]?result[key]:"";
            }
            if (result.province && result.city && result.area) {
              this.checkInfo.addressArray = [
                result.province,
                result.city,
                result.area,
              ];
            }
          } else {
            this.personalInfo = {
              userId: 1,
              companyName: "",
              companyContact: "",
              phone: "",
              telephone: "",
              qq: "",
              email: "",
              province: "",
              city: "",
              area: "",
              address: "",
              certificationType: "",
              certificationCompanyName: "",
              certificationCompanyCode: "",
              certificationCompanyLicense: "",
              certificationPersonName: "",
              certificationIdCard: "",
              certificationPersonIdCardFront: "",
              certificationPersonIdCardBack: "",
              certificationStatus: "",
              bankName: "",
              bankCard: "",
              companyAddress: "",
              bankPhone: "",
              billingType: "",
              balance: 0,
            };
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => { });
    },
    // 快捷输入
    toCheckInfo() {
      const result = smart(String(this.checkInfo.textarea));
      for(let key in result){
                this.checkInfo[key] = result[key]?result[key]:"";
            }
            if (result.province && result.city && result.area) {
              this.checkInfo.addressArray = [
                result.province,
                result.city,
                result.area,
              ];
            }
    },
    toQQ() {
      window.open(`tencent://message/?uin=${this.topInfo.orderQQ}`);
    },
   async getcategory() {
     await this.resetForm(); // 重置表单
      this.categoryList = [];
      categoryListApi({
        paperType: this.paperType,
        paperCategoryId: this.paperType === "1" ? this.parentId : 1,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.categoryList = res.resultData.records || [];
            this.paperCategoryId =
              this.categoryList.length > 0
                ? this.categoryList[0].paperCategoryId
                : "";
          } else {
            this.categoryList = [];
            this.paperCategoryId = "";
          }
        })
        .finally(() => {
          this.getUserInfo();
          if (this.paperCategoryId) {
            this.getCateConfig(this.paperCategoryId);
          }
        });
    },
    // 选择不干胶类型  材料类型
    checkPaperCategory(cate) {
      this.paperCategoryId = cate.paperCategoryId;
      if (this.paperCategoryId) {
        this.getCateConfig(this.paperCategoryId);
      }
    },
    getCateConfig(paperCategoryId) {
      if (!paperCategoryId) {
        return;
      }
      this.cleanPrice();
      categoryDetailApi({
        paperCategoryId: paperCategoryId,
      })
        .then((res) => {
          if (res.resultStatus) {
            const result = res.resultData;
            this.cateConfig.categoryName = result.categoryName
              ? result.categoryName
              : "";
            this.cateConfig.paperSize = result.paperSize
              ? result.paperSize.split(";")
              : [];
            if (this.cateConfig.paperSize.length > 0) {
              this.checkInfo.pageSize = this.cateConfig.paperSize[0];
              const resultpaperSize = this.cateConfig.paperSize[0].split("*");
              if (resultpaperSize.length === 2) {
                this.checkInfo.paperSizeHeight = resultpaperSize[0];
                this.checkInfo.paperSizeWeight = resultpaperSize[1];
              }
            }
            this.cateConfig.shipmentArrangement = result.shipmentArrangement
              ? result.shipmentArrangement.split(";")
              : [];
            if (this.cateConfig.shipmentArrangement.length > 0) {
              this.checkInfo.shipmentArrangement =
                this.cateConfig.shipmentArrangement[0];
            }
            this.cateConfig.tectorial = result.tectoria? result.tectoria.split(";"): [];
              if (this.cateConfig.tectorial.length > 0) {
              this.checkInfo.tectorial = this.cateConfig.tectorial[0];
            }
            this.cateConfig.paperNum = result.paperNum
              ? result.paperNum.split(";")
              : [];

            this.cateConfig.tectorialList = result.tectorialList
              ? result.tectorialList
              : [];
            this.cateConfig.otherProcess = result.otherProcess ? result.otherProcess.split(";")
              : [];
            this.cateConfig.otherProcessList = result.otherProcessList
              ? result.otherProcessList
              : [];
            if (this.cateConfig.tectorial.length > 0) {
              this.checkInfo.tectorial = this.cateConfig.tectorial[0];
              const quantityPrice = this.cateConfig.tectorialList.filter(
                (f) => f.tectorial === this.checkInfo.tectorial
              );
              if (quantityPrice.length > 0) {
                this.cateConfig.quantityPrice = quantityPrice
                  ? quantityPrice[0].quantityPrice.map((f) => {
                    const obj = {
                      orderPrice: 0,
                      ...f,
                    };
                    return obj;
                  })
                  : [];
                if (this.cateConfig.quantityPrice.length > 0) {
                  this.checkInfo.orderNum =
                    this.cateConfig.quantityPrice[0].quantity;
                  this.customizeObj.orderNum = this.customizeObj.orderNum
                    ? this.customizeObj.orderNum
                    : this.cateConfig.quantityPrice[0].quantity;
                  this.getPriceFun();
                }
              }
            }
            if (this.cateConfig.otherProcess.length > 0) {
              this.checkInfo.otherProcess = this.cateConfig.otherProcess[0];
              const quantityPrice = this.cateConfig.otherProcessList.filter(
                (f) => f.otherProcess === this.checkInfo.otherProcess
              );
              if (quantityPrice.length > 0) {
                this.cateConfig.quantityPrice = quantityPrice
                  ? quantityPrice[0].quantityPrice.map((f) => {
                    const obj = {
                      orderPrice: 0,
                      ...f,
                    };
                    return obj;
                  })
                  : [];
                if (this.cateConfig.quantityPrice.length > 0) {
                  this.checkInfo.orderNum =
                    this.cateConfig.quantityPrice[0].quantity;
                  this.customizeObj.orderNum = this.customizeObj.orderNum
                    ? this.customizeObj.orderNum
                    : this.cateConfig.quantityPrice[0].quantity;
                  this.getPriceFun();
                }
              }
            }
          }
        })
        .finally(() => {
          if (this.paperType === "2") {
            this.checkInfo.productMode = "切成品";
          }
          if (this.paperType === "3" || this.paperType === "4") {
            this.checkInfo.moldingProcess = [];
            this.checkInfo.packageCorediameter = "";
            this.checkInfo.packageMarkingDirection = "";
            this.checkInfo.packageMarkingWeight = "";
            this.checkInfo.packageMarkingWeightPaper = "";
            this.checkInfo.packageMarkingWeightLength = "";
          }
          if (this.paperType === "5") {
            this.checkInfo.printingSurface = "彩色单面";
            this.checkInfo.moldingType = "切成品";
            this.checkInfo.packageType = "标准包";
          }
        });
    },
    checkpageSize(label) {
      const array = label.split("*");
      if (array.length === 2) {
        this.checkInfo.paperSizeHeight = array[0];
        this.checkInfo.paperSizeWeight = array[1];
      } else {
        this.$message.warn("该配置异常，请联系管理员");
      }
      const quantityPrice = this.cateConfig.tectorialList.filter(
        (f) => f.tectorial === this.checkInfo.tectorial
      );
      if (quantityPrice.length > 0) {
        this.cateConfig.quantityPrice = quantityPrice
          ? quantityPrice[0].quantityPrice
          : [];
      }
      this.cateConfig.quantityPrice.forEach((f) => {
        f.orderPrice = null;
      });
      // this.cleanPrice();
    },
    checkOrderNum(data) {
      this.checkInfo.orderNum = data.quantity;
      this.getPriceFun();
    },
    checktectorial(label) {
      this.checkInfo.tectorial = label;
      this.checkInfo.orderNum = "";
      const quantityPrice = this.cateConfig.tectorialList.filter(
        (f) => f.tectorial === this.checkInfo.tectorial
      );
      if (quantityPrice.length > 0) {
        this.cateConfig.quantityPrice = quantityPrice
        ? quantityPrice[0].quantityPrice
        : [];
      }
      // this.cleanPrice();
    },
    checkOtherProcess(){
      this.checkInfo.otherProcess = label;
      this.checkInfo.orderNum = "";
      const quantityPrice = this.cateConfig.otherProcessList.filter(
        (f) => f.otherProcess === this.checkInfo.otherProcess
      );
      if (quantityPrice.length > 0) {
        this.cateConfig.quantityPrice = quantityPrice
          ? quantityPrice[0].quantityPrice
          : [];
      }
    },
    changePrintNum() {
      // this.cleanPrice();
    },
    // 查看说明
    toSeeShow(type) {
      switch (type) {
        // 出货排列 单款拼大张
        case "shipmentArrangement":
          this.tipsModel = {
            flag: true,
            title: "出货排列-单款拼大张",
            type: "shipmentArrangement",
          };
          break;
        case "cutType":
          this.tipsModel = {
            flag: true,
            title: "模切类型",
            type: "cutType",
          };
          break;
        case "packageCorediameter":
          this.tipsModel = {
            flag: true,
            title: "卷芯直径",
            type: "packageCorediameter",
          };
          break;
        case "packageMarkingDirection":
          this.tipsModel = {
            flag: true,
            title: "出标方向",
            type: "packageMarkingDirection",
          };
          break;
        case "packageMarkingWeight":
          this.tipsModel = {
            flag: true,
            title: "出标宽度",
            type: "packageMarkingWeight",
          };
          break;

        default:
          break;
      }
    },
    // 清空报价
    cleanPrice() {
      this.orderPrice = 0; // 订单金额
      this.orderTotalPrice = 0; //总金额
      this.weight = ""; // 预估重量
      this.freightPrice = ""; //快递
      this.checkInfo.orderNum = 0;
      this.cateConfig.quantityPrice.forEach((f) => {
        f.orderPrice = null;
      });
      this.customizeObj.show = false;
      // 保存地址相关字段，避免切换材料类型时清空用户已填写的地址
      const addressInfo = {
        addressArray: this.checkInfo.addressArray,
        address: this.checkInfo.address,
        province: this.checkInfo.province,
        city: this.checkInfo.city,
        area: this.checkInfo.area,
        street: this.checkInfo.street,
        contactName: this.checkInfo.contactName,
        phone: this.checkInfo.phone,
        textarea: this.checkInfo.textarea,
      };
      this.checkInfo = {
        pageSize: "",
        paperSizeWeight: "",
        paperSizeHeight: "",
        shipmentArrangement: "",
        shipmentArrangementLongSide: "",
        shipmentArrangementShortSide: "",
        cutType: "随文件", // 模切类型
        tectorial: "",
        otherProcess: "",
        printNum: 0,
        orderNum: 0,
        productType: "宣传类不干胶",
        deliveryType: "代发快递",
        expressName: "平安达",
        userCouponId: "",
        addressArray: addressInfo.addressArray,
        address: addressInfo.address,
        province: addressInfo.province,
        city: addressInfo.city,
        area: addressInfo.area,
        street: addressInfo.street,
        contactName: addressInfo.contactName,
        phone: addressInfo.phone,
        textarea: addressInfo.textarea,
        productMode: "",
        specialProcess: [],
        specialProcessBronzing: "",
        specialProcessBronzingLong: "",
        specialProcessBronzingShort: "",
        specialProcessUvLong: "",
        specialProcessUvShort: "",
        moldingProcess: [],
        moldingProcessDieType: "",
        packageCorediameter: "",
        packageMarkingDirection: "",
        packageMarkingWeight: "",
        packageMarkingWeightPaper: "",
        packageMarkingWeightLength: "",
        moldingType: "",
        packageType: "",
        printingSurface: "",
      }
    },
    // 点击报价
    getPriceFun() {
      if (!this.checkInfo.orderNum) {
        return;
      }
      orderPriceApi({
        paperCategoryId: this.paperCategoryId,
        paperType: this.paperType,
        paperSizeHeight: this.checkInfo.paperSizeHeight,
        paperSizeWeight: this.checkInfo.paperSizeWeight,
        tectorial:this.checkInfo.tectorial,
        otherProcess:this.checkInfo.otherProcess.otherProcess,
        orderNum: this.checkInfo.orderNum,
        printNum: this.checkInfo.printNum,
        expressName: this.checkInfo.expressName,
        province: this.checkInfo.province,
        deliveryType: this.checkInfo.deliveryType,
        quotationStatus:1, // 1:报价 2:下单
        userCouponId: this.checkInfo.userCouponId,//优惠券id
      })
        .then((res) => {
          if (res.resultStatus) {
            this.orderPrice = res.resultData.orderPrice || 0;
            this.orderTotalPrice = res.resultData.orderTotalPrice || 0;
            this.freightPrice = res.resultData.freightPrice || 0;
            this.weight = res.resultData.weight || 0;
            const index = this.cateConfig.quantityPrice.findIndex(
              (f) => f.quantity === this.checkInfo.orderNum
            );
            if (index >= 0) {
              this.cateConfig.quantityPrice[index].orderPrice =
                +this.orderPrice;
            }
          } else {
            this.orderPrice = 0;
            this.orderTotalPrice = 0;
            this.freightPrice = 0;
            this.weight = 0;
          }
        })
        .finally(() => {
          this.getCouponInfo(this.orderPrice);
          this.toQuotation();
        });
    },
    toQuotation() {
      sureOrderApi({
        paperCategoryId: this.paperCategoryId,
        paperType: this.paperType,
        shipmentArrangement: this.checkInfo.shipmentArrangement,
        shipmentArrangementShortSide:
          this.checkInfo.shipmentArrangementShortSide,
        shipmentArrangementLongSide: this.checkInfo.shipmentArrangementLongSide,
        cutType: this.checkInfo.cutType,
        paperSizeHeight: this.checkInfo.paperSizeHeight,
        paperSizeWeight: this.checkInfo.paperSizeWeight,
        tectorial: this.checkInfo.tectorial,
        otherProcess: this.checkInfo.otherProcess,
        productType: this.checkInfo.productType,
        orderNum: this.checkInfo.orderNum,
        printNum: this.checkInfo.printNum,
        expressName: this.checkInfo.expressName,
        deliveryType: this.checkInfo.deliveryType,
        province: this.checkInfo.province,
        city: this.checkInfo.city,
        area: this.checkInfo.area,
        // street: this.checkInfo.street,
        address: this.checkInfo.address,
        phone: this.checkInfo.phone,
        contactName: this.checkInfo.contactName,
        userCouponId: this.checkInfo.userCouponId,
        fileName: this.fileModel.fileName,
        fileUrl: this.fileModel.fileUrl,
        payType: this.fileModel.payType,
        authenticationFileSuffix1: this.fileModel.authenticationFileSuffix1,
        authenticationUrl1: this.fileModel.authenticationUrl1,
        authenticationFileSuffix2: this.fileModel.authenticationFileSuffix2,
        authenticationUrl2: this.fileModel.authenticationUrl2,

        productMode: this.checkInfo.productMode,
        specialProcess:
          this.checkInfo.specialProcess.length > 0
            ? this.checkInfo.specialProcess.join(";")
            : "",
        specialProcessBronzing: this.checkInfo.specialProcessBronzing,
        specialProcessBronzingLong: this.checkInfo.specialProcessBronzingLong,
        specialProcessBronzingShort: this.checkInfo.specialProcessBronzingShort,
        specialProcessUvLong: this.checkInfo.specialProcessUvLong,
        specialProcessUvShort: this.checkInfo.specialProcessUvShort,
        moldingProcess: this.checkInfo.moldingProcess.join(";"),
        moldingProcessDieType: this.checkInfo.moldingProcessDieType,
        packageCorediameter: this.checkInfo.packageCorediameter,
        packageMarkingDirection: this.checkInfo.packageMarkingDirection,
        packageMarkingWeight: this.checkInfo.packageMarkingWeight,
        packageMarkingWeightPaper: this.checkInfo.packageMarkingWeightPaper,
        packageMarkingWeightLength: this.checkInfo.packageMarkingWeightLength,
        printingSurface: this.checkInfo.printingSurface,
        moldingType: this.checkInfo.moldingType,
        packageType: this.checkInfo.packageType,
        quotationStatus: 1,
        payment: this.orderTotalPrice,
      })
        .then((res) => {
          //询价返回数据
          if(res.errorCode){
            this.$message.error(res.errorMsg);
          }
        })
    },
    getCouponInfo(orderPrice) {
      this.userCouponInfo = {};
      this.userCouponList = [];
      myCouponListApi({
        orderPrice: orderPrice,
        userStatus: "UN_USE",
        pageNo: 1,
        pageSize: 10,
      })
        .then((res) => {
          if (res.resultStatus) {
            const result = res.resultData.records || [];
            if (result.length > 0) {
              this.userCouponList = result || [];
              this.userCouponInfo = {
                useStatus: false,
                ...result[0],
              };
              this.checkInfo.userCouponId = result[0].userCouponId;
            } else {
              this.checkInfo.userCouponId = null;
            }
          }
        })
        .finally(() => {
          if (orderPrice > this.userCouponInfo.couponLimitprice) {
            this.userCouponInfo.userStatus = true;
            this.orderPrice =
              Number(orderPrice) - Number(this.userCouponInfo.couponPrice);
          }
        });
    },
    getExpressNameList() {
      expressListApi().then((res) => {
        if (res.resultStatus) {
          this.expressList = res.resultData.expressList || [];
        } else {
          this.expressList = [];
        }
      });
    },
    changeAddressArray() {
      if (this.checkInfo.addressArray.length === 3) {
        this.checkInfo.province = this.checkInfo.addressArray[0];
        this.checkInfo.city = this.checkInfo.addressArray[1];
        this.checkInfo.area = this.checkInfo.addressArray[2];
        // this.checkInfo.street = this.checkInfo.addressArray[3];
      }
      this.getPriceFun()
    },
    toCopy() {
      let freightPriceText =
        this.checkInfo.deliveryType !== "上门自取"
          ? `-运费：${this.freightPrice}元`
          : "";
      const text = `${this.checkInfo.paperSizeHeight}x${this.checkInfo.paperSizeWeight
        }mm-${this.checkInfo.orderNum}张-${this.cateConfig.categoryName}-模切${this.checkInfo.cutType
        }-${this.checkInfo.shipmentArrangement}-${this.checkInfo.tectorial}
      总价：${this.orderPrice}元${freightPriceText ? freightPriceText : ""
        }-预估重量：${this.weight}kg`;
      this.sureCopy(text);
    },
    async toCopyTwo() {
      let specialProcessText = "";
      if (this.checkInfo.specialProcess.length > 0) {
        await this.checkInfo.specialProcess.forEach((f) => {
          if (f === "烫金") {
            const specialText =
              f +
              "[" +
              this.checkInfo.specialProcessBronzingLong +
              "x" +
              this.checkInfo.specialProcessBronzingShort +
              "]" +
              this.checkInfo.specialProcessBronzing;
            specialProcessText = specialProcessText + specialText + "_";
          } else if (f === "局部UV") {
            const specialText2 =
              f +
              "[" +
              this.checkInfo.specialProcessUvLong +
              "x" +
              this.checkInfo.specialProcessUvShort +
              "]";
            specialProcessText = specialProcessText + specialText2 + "_";
          } else {
            specialProcessText = specialProcessText + f + "_";
          }
        });
      }
      let freightPriceText =
        this.checkInfo.deliveryType !== "上门自取"
          ? `-运费：${this.freightPrice}元`
          : "";
      const text = `${this.checkInfo.paperSizeHeight}x${this.checkInfo.paperSizeWeight
        }mm-${this.checkInfo.orderNum}张-${this.cateConfig.categoryName}-${this.checkInfo.productMode
        }-${specialProcessText ? specialProcessText : ""}${this.checkInfo.shipmentArrangement
        }-${this.checkInfo.tectorial}
      总价：${this.orderPrice}元${freightPriceText ? freightPriceText : ""
        }-预估重量：${this.weight}kg`;
      this.sureCopy(text);
    },
    toCopyThree() {
      let freightPriceText =
        this.checkInfo.deliveryType !== "上门自取"
          ? `-运费：${this.freightPrice}元`
          : "";
      const text = `${this.checkInfo.paperSizeHeight}x${this.checkInfo.paperSizeWeight
        }mm-${this.checkInfo.orderNum}张-${this.cateConfig.categoryName}-${this.checkInfo.productMode
        }-卷芯直径${this.checkInfo.packageCorediameter}-${this.checkInfo.packageMarkingDirection
        }-${this.checkInfo.packageMarkingWeight}-每卷${this.checkInfo.packageMarkingWeightPaper
        }张-每卷${this.checkInfo.packageMarkingWeightLength}米-${this.checkInfo.shipmentArrangement
        }-${this.checkInfo.tectorial}
      总价：${this.orderPrice}元${freightPriceText ? freightPriceText : ""
        }-预估重量：${this.weight}kg`;
      this.sureCopy(text);
    },
    toCopyFour() {
      let freightPriceText =
        this.checkInfo.deliveryType !== "上门自取"
          ? `-运费：${this.freightPrice}元`
          : "";
      const text = `${this.checkInfo.paperSizeHeight}x${this.checkInfo.paperSizeWeight
        }mm-${this.checkInfo.orderNum}张-${this.cateConfig.categoryName}-${this.checkInfo.productMode
        }-卷芯直径${this.checkInfo.packageCorediameter}-${this.checkInfo.packageMarkingDirection
        }-${this.checkInfo.packageMarkingWeight}-每卷${this.checkInfo.packageMarkingWeightPaper
        }张-每卷${this.checkInfo.packageMarkingWeightLength}米-${this.checkInfo.shipmentArrangement
        }-${this.checkInfo.tectorial}
      总价：${this.orderPrice}元${freightPriceText ? freightPriceText : ""
        }-预估重量：${this.weight}kg`;
      this.sureCopy(text);
    },
    toCopyFive() {
      let freightPriceText =
        this.checkInfo.deliveryType !== "上门自取"
          ? `-运费：${this.freightPrice}元`
          : "";
      const text = `${this.checkInfo.paperSizeHeight}x${this.checkInfo.paperSizeWeight
        }mm-${this.checkInfo.orderNum}张-${this.cateConfig.categoryName}
      -印面${this.checkInfo.printingSurface}
      -成型类型${this.checkInfo.moldingType}
      -包装方式${this.checkInfo.packageType}
      -${this.checkInfo.shipmentArrangement}-${this.checkInfo.tectorial}
      总价：${this.orderPrice}元${freightPriceText ? freightPriceText : ""
        }-预估重量：${this.weight}kg`;
      this.sureCopy(text);
    },
    sureCopy(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "absolute";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
    changeTab(value) {
      this.$emit("tabchange", value);
    },
    sureOrder() {
      if (!this.agreeCheck) {
        this.$message.warning(
          "请阅读并同意方和印刷版权声明以及知识产权要求规范"
        );
        return;
      }
      if (!this.checkInfo.orderNum) {
        this.$message.warning("请选择或输入自定义出货数量");
        return;
      }
      if (this.paperType === "5") {
        if (!this.checkInfo.printingSurface) {
          this.$message.warning("请选择印面");
          return;
        }
        if (!this.checkInfo.moldingType) {
          this.$message.warning("请选择成型类型");
          return;
        }
        if (!this.checkInfo.packageType) {
          this.$message.warning("请选择包装方式");
          return;
        }
      }
      this.fileModel = {
        flag: true,
        title: "文件上传",
        fileName: "",
        fileUrl: "",
        payType: "PRE_STORAGE",
        authenticationId1: '',
        authenticationFileSuffix1: "",
        authenticationUrl1: "",
        authenticationId2: '',
        authenticationFileSuffix2: "",
        authenticationUrl2: "",
        onOk: this.sureOrderOk,
      };
      this.getauthenList();
    },
    // 上传文件
    handleUpdataFile(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        const loading = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if (file) {
          const form = new FormData();
          form.append("file", file);
          getOssAuth(form).then((res) => {
            loading.close();
            if (res.resultStatus) {
              this.fileModel.fileName = file.name;
              this.fileModel.fileUrl = res.resultData.fileLink;
            }
          }).catch((err) => {
            loading.close();
            });

        }
      }
    },
    // 删除图片
    deleteFile() {
      this.fileModel.fileName = "";
      this.fileModel.fileUrl = "";
    },
    //支付按钮事件
    sureOrderOk() {
      if (!this.fileModel.fileUrl) {
        this.$message.warning("请先上传文件");
        return;
      }
      if (this.orderTotalPrice > this.personalInfo.balance) {
        this.$message.warning("可用余额不足，请充值");
        return;
      }
      sureOrderApi({
        paperCategoryId: this.paperCategoryId,
        paperType: this.paperType,
        shipmentArrangement: this.checkInfo.shipmentArrangement,
        shipmentArrangementShortSide:
          this.checkInfo.shipmentArrangementShortSide,
        shipmentArrangementLongSide: this.checkInfo.shipmentArrangementLongSide,
        cutType: this.checkInfo.cutType,
        paperSizeHeight: this.checkInfo.paperSizeHeight,
        paperSizeWeight: this.checkInfo.paperSizeWeight,
        tectorial: this.checkInfo.tectorial,
        otherProcess: this.checkInfo.otherProcess,
        productType: this.checkInfo.productType,
        orderNum: this.checkInfo.orderNum,
        printNum: this.checkInfo.printNum,
        expressName: this.checkInfo.expressName,
        deliveryType: this.checkInfo.deliveryType,
        province: this.checkInfo.province,
        city: this.checkInfo.city,
        area: this.checkInfo.area,
        address: this.checkInfo.address,
        phone: this.checkInfo.phone,
        contactName: this.checkInfo.contactName,
        userCouponId: this.checkInfo.userCouponId,
        fileName: this.fileModel.fileName,
        fileUrl: this.fileModel.fileUrl,
        payType: this.fileModel.payType,
        authenticationFileSuffix1: this.fileModel.authenticationFileSuffix1,
        authenticationUrl1: this.fileModel.authenticationUrl1,
        authenticationFileSuffix2: this.fileModel.authenticationFileSuffix2,
        authenticationUrl2: this.fileModel.authenticationUrl2,

        productMode: this.checkInfo.productMode,
        specialProcess:
          this.checkInfo.specialProcess.length > 0
            ? this.checkInfo.specialProcess.join(";")
            : "",
        specialProcessBronzing: this.checkInfo.specialProcessBronzing,
        specialProcessBronzingLong: this.checkInfo.specialProcessBronzingLong,
        specialProcessBronzingShort: this.checkInfo.specialProcessBronzingShort,
        specialProcessUvLong: this.checkInfo.specialProcessUvLong,
        specialProcessUvShort: this.checkInfo.specialProcessUvShort,
        moldingProcess: this.checkInfo.moldingProcess.join(";"),
        moldingProcessDieType: this.checkInfo.moldingProcessDieType,
        packageCorediameter: this.checkInfo.packageCorediameter,
        packageMarkingDirection: this.checkInfo.packageMarkingDirection,
        packageMarkingWeight: this.checkInfo.packageMarkingWeight,
        packageMarkingWeightPaper: this.checkInfo.packageMarkingWeightPaper,
        packageMarkingWeightLength: this.checkInfo.packageMarkingWeightLength,
        printingSurface: this.checkInfo.printingSurface,
        moldingType: this.checkInfo.moldingType,
        packageType: this.checkInfo.packageType,
        quotationStatus: 0,
        payment: this.orderTotalPrice,
      })
        .then((res) => {
          if (res.resultStatus) {
            if (res.resultData.orderStatus === "UNPAY") {
              this.$message.success("订单已生成，请尽快支付");
            } else if (res.resultData.orderStatus === "VERIFYING ") {
              this.$message.success("已成功下单");
            }
            this.fileModel.flag = false;
            if (res.resultData.wxUrl) {
              this.payModel = {
                flag: true,
                title: "扫码支付",
                orderId: res.resultData.orderId,
                payStatus: false,
                wxUrl: res.resultData.wxUrl,
              };
            }
          } else {
            this.$message.warning(res.errorMessage);
          }
        })
        .finally(() => {
          if (!this.payModel.flag) {
            this.$store.commit("UPDATE_USER_COUPON", null);
            this.$store.commit("UPDATE_ACTIVE_MENU", "6-2");
            this.$router.push({
              name: "orderManege",
            });
          }
        });
    },
    changeAuthenticationId1() {
      const result = this.authenticationId1List.filter(f => f.value === this.fileModel.authenticationId1)
      if (result.length === 1) {
        this.fileModel.authenticationFileSuffix1 = result[0].authenticationFileSuffix;
        this.fileModel.authenticationUrl1 = result[0].authenticationUrl
      }
    },
    changeAuthenticationId2() {
      const result = this.authenticationId2List.filter(f => f.value === this.fileModel.authenticationId2)
      if (result.length === 1) {
        this.fileModel.authenticationFileSuffix2 = result[0].authenticationFileSuffix;
        this.fileModel.authenticationUrl2 = result[0].authenticationUrl
      }
    },
    toMycoupon() {
      // this.$store.commit("UPDATE_ACTIVE_MENU", "6-12");
      // this.$router.push({
      //   name: "myCoupon",
      // });
      this.couponModel = {
        flag: true,
        title: "可用优惠券",
      };
    },
    toUseCoupon(data) {
      this.checkInfo.userCouponId = data.userCouponId;
      this.userCouponInfo = {
        useStatus: false,
        ...data,
      };
      this.couponModel.flag = false;
    },
    getauthenList() {
      authenticationListApi({
        pageNo: 1,
        pageSize: 999,
        authenticationType: "BRAND_TRADE_MARK",
        verifyStatus: "SUCCESS",
        expirType: false,
      }).then((res) => {
        if (res.resultStatus) {
          this.authenticationId1List = (
            res.resultData.authenticationList || []
          ).map((f) => {
            const obj = {
              label: f.authenticationTitle,
              value: f.authenticationId,
              ...f,
            };
            return obj;
          });
        }
      });
      authenticationListApi({
        pageNo: 1,
        pageSize: 999,
        authenticationType: "PROXY",
        verifyStatus: "SUCCESS",
        expirType: false,
      }).then((res) => {
        if (res.resultStatus) {
          this.authenticationId2List = (
            res.resultData.authenticationList || []
          ).map((f) => {
            const obj = {
              label: f.authenticationTitle,
              value: f.authenticationId,
              ...f,
            };
            return obj;
          });
        }
      });
    },
    toUpload(type) {
      this.addModel = {
        flag: true,
        authenticationId: 0,
        authenticationTitle: "",
        authenticationExpirTime: "",
        authenticationType: type === "1" ? "BRAND" : "PROXY",
        authenticationFileSuffix: "",
        authenticationUrl: "",
        fileName: "",
        suffix: "",
      };
    },
    sureAdd() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          authenticationAddApi({
            authenticationId: this.addModel.authenticationId,
            authenticationTitle: this.addModel.authenticationTitle,
            authenticationExpirTime: this.$moment(
              this.addModel.authenticationExpirTime
            ).format("YYYY-MM-DD"),
            authenticationType: this.addModel.authenticationType,
            authenticationFileSuffix: this.addModel.authenticationFileSuffix,
            authenticationUrl: this.addModel.authenticationUrl,
          })
            .then((res) => {
              if (res.resultStatus) {
                this.$message.success("新增授权书成功");
                this.addModel.flag = false;
                this.getauthenList();
              } else {
                this.$message.warning(res.errorMessage);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    // 上传文件
    authenticationUrlFile(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        if (file) {
          const form = new FormData();
          form.append("file", file);
          getOssAuth(form).then((res) => {
            if (res.resultStatus) {
              this.addModel.authenticationUrl = res.resultData.fileLink;
              this.addModel.authenticationFileSuffix = res.resultData.suffix;
              this.addModel.fileName = res.resultData.fileName;
            }
          });
        }
      }
    },
    // 自定义出货数量
    async changeOrderNum() {
      const oldArray = this.cateConfig.quantityPrice.map((f) => {
        return f.quantity;
      });
      if (!oldArray.includes(this.customizeObj.orderNum)) {
        this.customizeObj.show = true;
        this.checkInfo.orderNum = +this.customizeObj.orderNum;
        const result = await orderPriceApi({
          paperCategoryId: this.paperCategoryId,
          paperType: this.paperType,
          paperSizeHeight: this.checkInfo.paperSizeHeight,
          paperSizeWeight: this.checkInfo.paperSizeWeight,
          tectorial:this.checkInfo.tectorial,
          otherProcess:this.checkInfo.otherProcess.otherProcess,
          orderNum: this.checkInfo.orderNum,
          printNum: this.checkInfo.printNum,
          expressName: this.checkInfo.expressName,
          province: this.checkInfo.province,
          deliveryType: this.checkInfo.deliveryType,
          // userCouponId: this.checkInfo.userCouponId,//优惠券id
          quotationStatus:1, // 1:报价 2:下单
        });
        this.orderPrice = result.resultData.orderPrice || 0;
        this.orderTotalPrice = result.resultData.orderTotalPrice || 0;
        this.freightPrice = result.resultData.freightPrice || 0;
        this.weight = result.resultData.weight || 0;
        this.customizeObj.orderPrice = result.resultData.orderPrice;
        this.customizeObj.quantity = this.checkInfo.orderNum;
        this.getPriceFun();
      } else {
        this.checkInfo.orderNum = +this.customizeObj.orderNum;
        this.getPriceFun();
      }
    },
    changeShipment() {
      if (
        this.checkInfo.productMode === "啤成品(模切)" &&
        this.checkInfo.shipmentArrangement !== "任意"
      ) {
        this.checkInfo.productMode = "切成品";
      }
    },
    toRecharge() {
      this.fileModel.flag = false;
      this.$store.commit("UPDATE_ACTIVE_MENU", "6-9");
      this.$router.push({
        name: "prestorage",
      });
    },
    // 加入自命名下单
    addCustomOrder() {
      if (!this.orderPrice) return;
      
      // 创建订单项
      const orderItem = {
        id: Date.now(),
        checkInfo: JSON.parse(JSON.stringify(this.checkInfo)),
        fileModel: JSON.parse(JSON.stringify(this.fileModel)),
        paperCategoryId: this.paperCategoryId,
        paperType: this.paperType,
        payment: this.orderTotalPrice,
        orderTotalPrice: this.orderTotalPrice,
      };
      
      // 添加到自命名下单列表
      this.customOrders.push(orderItem);
      
      // 更新总价
      this.updateCustomOrderTotal();
      
      // 保存到localStorage
      localStorage.setItem('customOrders', JSON.stringify(this.customOrders));
      
      // 关闭文件上传弹窗
      this.fileModel.flag = false;

      this.toggleCustomOrderList();
      
      // 提示用户
      this.$message.success('已成功加入订单');
    },
    // 切换自命名下单组件收缩/展开
    toggleCustomOrderList() {
      this.customOrderCollapsed = !this.customOrderCollapsed;
      // 如果展开组件，自动显示订单列表
      if (!this.customOrderCollapsed) {
        this.customOrderListVisible = true;
      }
    },
    // 删除自命名下单
    removeCustomOrder(id) {
      this.customOrders = this.customOrders.filter(order => order.id !== id);
      this.updateCustomOrderTotal();
      // 更新localStorage
      localStorage.setItem('customOrders', JSON.stringify(this.customOrders));
      this.$message.success('已删除订单');
    },
    // 更新自命名下单总价
    updateCustomOrderTotal() {
      this.customOrderTotalPrice = this.customOrders.reduce((total, order) => {
        return total + Number(order.orderTotalPrice);
      }, 0);
    },
    scanOrder() {
      const orderPayDTOs = this.customOrders.map(order => {
        return {
          paperCategoryId: order.paperCategoryId,
          paperType: order.paperType,
          shipmentArrangement: order.checkInfo.shipmentArrangement,
          shipmentArrangementShortSide: order.checkInfo.shipmentArrangementShortSide,
          shipmentArrangementLongSide: order.checkInfo.shipmentArrangementLongSide,
          cutType: order.checkInfo.cutType,
          paperSizeHeight: order.checkInfo.paperSizeHeight,
          paperSizeWeight: order.checkInfo.paperSizeWeight,
          tectorial: order.checkInfo.tectorial,
          otherProcess: order.checkInfo.otherProcess,
          productType: order.checkInfo.productType,
          orderNum: order.checkInfo.orderNum,
          printNum: order.checkInfo.printNum,
          expressName: order.checkInfo.expressName,
          deliveryType: order.checkInfo.deliveryType,
          province: order.checkInfo.province,
          city: order.checkInfo.city,
          area: order.checkInfo.area,
          address: order.checkInfo.address,
          phone: order.checkInfo.phone,
          contactName: order.checkInfo.contactName,
          userCouponId: order.checkInfo.userCouponId,
          fileName: order.fileModel.fileName,
          fileUrl: order.fileModel.fileUrl,
          payType: "WECHAT_PAY",
          authenticationFileSuffix1: order.fileModel.authenticationFileSuffix1,
          authenticationUrl1: order.fileModel.authenticationUrl1,
          authenticationFileSuffix2: order.fileModel.authenticationFileSuffix2,
          authenticationUrl2: order.fileModel.authenticationUrl2,
          productMode: order.checkInfo.productMode,
          specialProcess: order.checkInfo.specialProcess.length > 0 ? order.checkInfo.specialProcess.join(";") : "",
          specialProcessBronzing: order.checkInfo.specialProcessBronzing,
          specialProcessBronzingLong: order.checkInfo.specialProcessBronzingLong,
          specialProcessBronzingShort: order.checkInfo.specialProcessBronzingShort,
          specialProcessUvLong: order.checkInfo.specialProcessUvLong,
          specialProcessUvShort: order.checkInfo.specialProcessUvShort,
          moldingProcess: order.checkInfo.moldingProcess.join(";"),
          moldingProcessDieType: order.checkInfo.moldingProcessDieType,
          packageCorediameter: order.checkInfo.packageCorediameter,
          packageMarkingDirection: order.checkInfo.packageMarkingDirection,
          packageMarkingWeight: order.checkInfo.packageMarkingWeight,
          packageMarkingWeightPaper: order.checkInfo.packageMarkingWeightPaper,
          packageMarkingWeightLength: order.checkInfo.packageMarkingWeightLength,
          printingSurface: order.checkInfo.printingSurface,
          moldingType: order.checkInfo.moldingType,
          packageType: order.checkInfo.packageType,
          quotationStatus: 0, // 默认值，根据需求调整
          payment: order.orderTotalPrice,
        };
      });
      wechatQrCodeApi(orderPayDTOs).then((res) => {
        if (res.resultStatus) {
          this.payModel = {
            flag: true,
            title: "扫码支付",
            orderNo: res.resultData.orderNo,
            payStatus: false,
            wxUrl: res.resultData.qrCodeUrl,
          };
          //加定时器判断是否支付成功
          setTimeout(() => {
            this.$refs.wechatPayDialog.checkPay();
          }, 1000);
        }else {
          this.$message.error(res.errorMessage || "获取二维码失败，请重试");
        }
      }).catch((error) => {
        console.error("获取二维码异常:", error);
        this.$message.error("网络错误，请检查网络连接");
      });
    },
    // 自命名下单确认支付
    customOrderCheckout() {
      if (this.customOrders.length === 0) return;
      // 构建OrderPayDTO列表，参考sureOrderApi的参数结构
      const orderPayDTOs = this.customOrders.map(order => {
        return {
          paperCategoryId: order.paperCategoryId,
          paperType: order.paperType,
          shipmentArrangement: order.checkInfo.shipmentArrangement,
          shipmentArrangementShortSide: order.checkInfo.shipmentArrangementShortSide,
          shipmentArrangementLongSide: order.checkInfo.shipmentArrangementLongSide,
          cutType: order.checkInfo.cutType,
          paperSizeHeight: order.checkInfo.paperSizeHeight,
          paperSizeWeight: order.checkInfo.paperSizeWeight,
          tectorial: order.checkInfo.tectorial,
          otherProcess: order.checkInfo.otherProcess,
          productType: order.checkInfo.productType,
          orderNum: order.checkInfo.orderNum,
          printNum: order.checkInfo.printNum,
          expressName: order.checkInfo.expressName,
          deliveryType: order.checkInfo.deliveryType,
          province: order.checkInfo.province,
          city: order.checkInfo.city,
          area: order.checkInfo.area,
          address: order.checkInfo.address,
          phone: order.checkInfo.phone,
          contactName: order.checkInfo.contactName,
          userCouponId: order.checkInfo.userCouponId,
          fileName: order.fileModel.fileName,
          fileUrl: order.fileModel.fileUrl,
          payType: order.fileModel.payType,
          authenticationFileSuffix1: order.fileModel.authenticationFileSuffix1,
          authenticationUrl1: order.fileModel.authenticationUrl1,
          authenticationFileSuffix2: order.fileModel.authenticationFileSuffix2,
          authenticationUrl2: order.fileModel.authenticationUrl2,
          productMode: order.checkInfo.productMode,
          specialProcess: order.checkInfo.specialProcess.length > 0 ? order.checkInfo.specialProcess.join(";") : "",
          specialProcessBronzing: order.checkInfo.specialProcessBronzing,
          specialProcessBronzingLong: order.checkInfo.specialProcessBronzingLong,
          specialProcessBronzingShort: order.checkInfo.specialProcessBronzingShort,
          specialProcessUvLong: order.checkInfo.specialProcessUvLong,
          specialProcessUvShort: order.checkInfo.specialProcessUvShort,
          moldingProcess: order.checkInfo.moldingProcess.join(";"),
          moldingProcessDieType: order.checkInfo.moldingProcessDieType,
          packageCorediameter: order.checkInfo.packageCorediameter,
          packageMarkingDirection: order.checkInfo.packageMarkingDirection,
          packageMarkingWeight: order.checkInfo.packageMarkingWeight,
          packageMarkingWeightPaper: order.checkInfo.packageMarkingWeightPaper,
          packageMarkingWeightLength: order.checkInfo.packageMarkingWeightLength,
          printingSurface: order.checkInfo.printingSurface,
          moldingType: order.checkInfo.moldingType,
          packageType: order.checkInfo.packageType,
          quotationStatus: 0, // 默认值，根据需求调整
          payment: order.orderTotalPrice,
        };
      });

      // 调用批量下单接口
      batchOrderApi( orderPayDTOs )
        .then(res => {
          if (res.resultStatus) {
            this.$message.success('批量下单成功');
            // 下单成功后清空列表
            this.customOrders = [];
            this.updateCustomOrderTotal();
            // 清空localStorage
            localStorage.removeItem('customOrders');
          } else {
            this.$message.error(res.errorMsg || '批量下单失败');
          }
        })
        .catch(err => {
          console.error('批量下单失败:', err);
          this.$message.error('批量下单失败，请稍后重试');
        });
    },
  },
  watch: {
    menuTitle() {
      this.getcategory();
    },
  },
};
</script>

<style lang="less" scoped>
.order_form_page {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;

  @media screen and (min-width: 480px) {
    .title_box {
      width: 100%;
      padding-bottom: 16px;
      border-bottom: 1px dashed #f2ae80;
      display: flex;
      align-items: center;

      .title {
        font-size: 24px;
        line-height: 26px;
        margin-right: 20px;
      }

      .subtitle {
        font-size: 14px;
        line-height: 1.5;
        color: #00a0e9;
        font-weight: bold;
      }

      @keyframes shake {
        0% {
          transform: rotate(0deg);
        }

        25% {
          transform: rotate(10deg);
        }

        50% {
          transform: rotate(0deg);
        }

        75% {
          transform: rotate(-10deg);
        }

        100% {
          transform: rotate(0deg);
        }
      }

      .small_img {
        width: 30px;
        position: absolute;
        animation: shake 0.5s infinite;
      }

      .detail_img {
        width: 100%;
      }
    }

    .form_box {
      margin: 10px 0;

      .item_box {
        display: flex;
        margin-bottom: 12px;

        .item_label {
          width: 100px;
          line-height: 26px;
          min-width: 100px;
          height: 26px;
          font-size: 13px;
          color: #000;
          text-align: center;
          white-space: nowrap;
          background-color: #aad8ee;
          margin-bottom: 4px;
          margin-right: 12px;
        }

        .nobg {
          background-color: #ffffff;
        }

        .required:before {
          content: "*";
          color: red;
        }

        .item_content {
          flex: 1;
          font-size: 14px;

          /deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
            border-bottom-color: #00a0e9;
            border-bottom: 2px solid #00a0e9;
            color: #00a0e9;
          }

          /deep/.el-tabs__item:hover {
            color: #00a0e9;
          }

          /deep/.el-button:focus,
          .el-button:hover {
            color: #00a0e9;
            border-color: #e4e7ed;
            background-color: #ffffff;
          }

          /deep/.el-radio__input.is-checked+.el-radio__label {
            color: #00a0e9;
          }

          /deep/.el-radio__input.is-checked .el-radio__inner {
            border-color: #00a0e9;
            background: #00a0e9;
          }

          /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            color: #fff !important;
            background-color: #00a0e9;
            border-color: #00a0e9;
            -webkit-box-shadow: -1px 0 0 0 #00a0e9;
            box-shadow: -1px 0 0 0 #e4e7ed;
          }

          /deep/.el-radio-button__orig-radio:hover+.el-radio-button__inner {
            color: #00a0e9;
            border-color: #00a0e9;
          }

          .Materials_computer {
            display: flex;
            flex-wrap: wrap;
            gap: 12px 0;

            .radio_btn {
              min-width: 170px;
              margin-right: 10px;
              margin-left: 0;
              border-radius: 5px;
              text-align: center;
            }

            .active {
              color: #00a0e9;
              border: 1px solid #00a0e9;
              box-shadow: 0 0 0 3px #e4e7ed;
            }
          }

          .product_num_btn {
            margin-right: 10px;

            .top_btn {
              min-width: 80px;
              max-width: 150px;
              font-size: 16px;
              line-height: 38px;
              text-align: center;
              font-weight: 700;
              border: 1px solid #e1e1e1;
            }

            .bottom_btn {
              border: 1px solid #d9d9d9;
              border-top: 0 solid #d9d9d9;
              border-radius: 0 0 4px 4px;
              overflow: hidden;
              font-size: 16px;
              font-weight: 700;
              line-height: 38px;
              text-align: center;
            }
          }

          .active_num {
            .top_btn {
              border: 1px solid #00a0e9;
              color: #00a0e9 !important;
            }

            .bottom_btn {
              border: 1px solid #00a0e9;
              color: #fff;
              background-color: #00a0e9;
            }
          }

          .getPrice {
            height: 32px;
            background-color: #00a0e9;
            color: #ffffff;
          }
        }
      }

      .offer {
        background: #f9f9fa;
        width: 88%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 46px;
        height: 100px;
        margin-top: 20px;
        box-sizing: border-box;
        position: relative;

        .params {
          font-size: 14px;
          color: #666;
          margin-bottom: 8px;
        }

        .price {
          font-size: 26px;
          color: #00a0e9;
        }

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }

        .btn {
          display: flex;
          align-items: center;
        }
      }

      .alret_box {
        width: calc(100% - 200px);
        margin-bottom: 12px;

        .alert {
          background-color: #fffbe6;
          border: 1px solid #ffe58f;
          padding: 10px 12px;
          font-size: 14px;
          color: red;
          display: flex;
          align-items: flex-start;
        }
      }

      .pay_btn {
        // color: #fff;
        // background-color: #00a0e9;
        // border-color: #00a0e9;
        font-size: 24px;
      }

      .address {
        display: block;
        padding-left: 86px;
        font-size: 13px;
        color: #00a0e9;
      }
    }
  }

  /* 自命名下单组件样式 */
  .custom-order-container {
    position: fixed;
    right: 0;
    top: 0;
    width: 700px;
    height: 100vh;
    background-color: #fff;
    border-left: 1px solid #e1e1e1;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
  }
  
  /* 组件收缩样式 */
  .custom-order-container.collapsed {
    width: 50px; /* 收缩后的宽度，只显示一个按钮 */
  }
  
  /* 收缩时标题文字竖排显示 */
  .custom-order-container.collapsed .custom-order-header h3 {
    writing-mode: vertical-lr;
    text-orientation: upright;
    font-size: 16px; /* 字体放大 */
    margin: 0;
    padding: 10px 0;
    letter-spacing: 2px;
    height: 120px; /* 高度调整 */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* 收缩时头部容器垂直布局（标题在下） */
  .custom-order-container.collapsed .custom-order-header {
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
  }

  /* 收缩时标题容器 */
  .custom-order-container.collapsed .custom-order-title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 收缩时按钮样式 - 图标显示 */
  .custom-order-container.collapsed .custom-order-header .el-button {
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 10px 0;
    border: none;
    background: transparent;
    box-shadow: none;
  }

  /* 移除按钮hover状态的边框 */
  .custom-order-container.collapsed .custom-order-header .el-button:hover {
    border: none;
    background: transparent;
    box-shadow: none;
  }
  
  /* 确保图标在各种状态下都能正常显示 */
  .custom-order-container .custom-order-header .el-button i {
    font-size: 16px;
  }
  
  /* 确保收缩时表单区域边距也相应调整 */
  .custom-order-container.collapsed ~ .title_box,
  .custom-order-container.collapsed ~ .form_box {
    margin-right: 60px;
  }
  
  /* 展开状态下的头部布局：按钮在左，标题在右 */
  .custom-order-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #e1e1e1;
  }

  /* 展开状态下的标题容器 */
  .custom-order-title {
    flex: 1;
  }

  /* 展开状态下的按钮样式 - 无边框 */
  .custom-order-container .custom-order-header .el-button {
    border: none;
    background: transparent;
    box-shadow: none;
    margin-right: 15px;
  }

  /* 展开状态下按钮hover样式 */
  .custom-order-container .custom-order-header .el-button:hover {
    border: none;
    background: transparent;
    box-shadow: none;
  }
  
  .custom-order-header h3 {
    margin: 0;
    font-size: 18px;
  }
  
  .custom-order-list {
    flex: 1;
    overflow-y: auto;
    padding: 15px;
  }
  
  .custom-order-empty {
    text-align: center;
    padding: 50px 0;
    color: #999;
  }
  
  .custom-order-items {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .custom-order-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    background-color: #f9f9f9;
  }
  
  .custom-order-info h4 {
    margin: 0 0 5px 0;
    font-size: 16px;
    color: #333;
  }
  
  .custom-order-desc {
    margin: 0 0 5px 0;
    font-size: 14px;
    color: #666;
  }
  
  .custom-order-price {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: bold;
    color: #00a0e9;
  }
  
  .custom-order-time {
    margin: 0;
    font-size: 12px;
    color: #999;
  }
  
  .custom-order-footer {
    padding: 15px;
    border-top: 1px solid #e1e1e1;
    background-color: #f5f5f5;
  }
  
  .custom-order-total {
    text-align: center;
  }
  
  /* 调整订单表单页面的边距，为右侧自命名下单组件留出空间 */
  .order_form_page .title_box,
  .order_form_page .form_box {
    margin-right: 360px;
  }
  
  @media only screen and (max-width: 480px) {
    .title_box {
      width: 100%;
      padding-bottom: 16px;
      border-bottom: 1px dashed #f2ae80;
      display: flex;
      flex-direction: column;
      align-content: flex-start;

      .title {
        font-size: 24px;
        line-height: 26px;
        margin-right: 20px;
        margin-top: 12px;
        margin-bottom: 4px;
      }

      .subtitle {
        font-size: 14px;
        line-height: 1.5;
        color: #00a0e9;
        font-weight: bold;
      }

      @keyframes shake {
        0% {
          transform: rotate(0deg);
        }

        25% {
          transform: rotate(10deg);
        }

        50% {
          transform: rotate(0deg);
        }

        75% {
          transform: rotate(-10deg);
        }

        100% {
          transform: rotate(0deg);
        }
      }

      .small_img {
        width: 30px;
        position: absolute;
        animation: shake 0.5s infinite;
      }

      .detail_img {
        width: 100%;
      }
    }

    .form_box {
      margin: 10px 0;

      .item_box {
        display: flex;
        // flex-direction: column;
        margin-bottom: 12px;

        .item_label {
          width: 100px;
          line-height: 26px;
          min-width: 100px;
          height: 26px;
          font-size: 13px;
          color: #000;
          text-align: center;
          white-space: nowrap;
          background-color: #00a0e9;
          margin-bottom: 4px;
          margin-right: 12px;
        }

        .nobg {
          background-color: #ffffff;
        }

        .required:before {
          content: "*";
          color: red;
        }

        .item_content {
          flex: 1;
          flex-wrap: wrap;
          font-size: 14px;

          /deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
            border-bottom-color: #00a0e9;
            border-bottom: 2px solid #00a0e9;
            color: #00a0e9;
          }

          /deep/.el-tabs__item:hover {
            color: #00a0e9;
          }

          /deep/.el-button:focus,
          .el-button:hover {
            color: #00a0e9;
            border-color: #00a0e9;
            background-color: #ffffff;
          }

          /deep/.el-radio__input.is-checked+.el-radio__label {
            color: #00a0e9;
          }

          /deep/.el-radio__input.is-checked .el-radio__inner {
            border-color: #00a0e9;
            background: #00a0e9;
          }

          /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            color: #fff !important;
            background-color: #00a0e9;
            border-color: #00a0e9;
            -webkit-box-shadow: -1px 0 0 0 #00a0e9;
            box-shadow: -1px 0 0 0 #00a0e9;
          }

          /deep/.el-radio-button__orig-radio:hover+.el-radio-button__inner {
            color: #00a0e9;
            border-color: #00a0e9;
          }

          .Materials_computer {
            display: flex;
            flex-wrap: wrap;
            gap: 12px 0;

            .radio_btn {
              min-width: 170px;
              margin-right: 10px;
              margin-left: 0;
              border-radius: 5px;
              text-align: center;
            }

            .active {
              color: #00a0e9;
              border: 1px solid #00a0e9;
              -webkit-box-shadow: 0 0 0 3px rgba(255, 104, 1, 0.08);
              box-shadow: 0 0 0 3px rgba(255, 104, 1, 0.3);
            }
          }

          .product_num_btn {
            margin-right: 10px;
            margin-bottom: 12px;

            .top_btn {
              min-width: 80px;
              max-width: 150px;
              font-size: 16px;
              line-height: 38px;
              text-align: center;
              font-weight: 700;
              border: 1px solid #e1e1e1;
            }

            .bottom_btn {
              border: 1px solid #d9d9d9;
              border-top: 0 solid #d9d9d9;
              border-radius: 0 0 4px 4px;
              overflow: hidden;
              font-size: 16px;
              font-weight: 700;
              line-height: 38px;
              text-align: center;
            }
          }

          .active_num {
            .top_btn {
              border: 1px solid #00a0e9;
              color: #00a0e9 !important;
            }

            .bottom_btn {
              border: 1px solid #00a0e9;
              color: #fff;
              background-color: #00a0e9;
            }
          }

          .getPrice {
            height: 32px;
            background-color: #00a0e9;
            color: #ffffff;
          }
        }
      }

      .offer {
        background: #f9f9fa;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px;
        margin-top: 20px;
        box-sizing: border-box;
        position: relative;

        .params {
          font-size: 14px;
          color: #666;
          margin-bottom: 8px;
        }

        .price {
          font-size: 26px;
          color: #00a0e9;
        }

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }

        .btn {
          display: flex;
          align-items: center;
        }
      }

      .alret_box {
        width: 100%;
        margin-bottom: 12px;

        .alert {
          background-color: #fffbe6;
          border: 1px solid #ffe58f;
          padding: 10px 12px;
          font-size: 14px;
          color: red;
          display: flex;
          align-items: flex-start;
        }
      }

      .pay_btn {
        // color: #fff;
        // background-color: #00a0e9;
        // border-color: #00a0e9;
        font-size: 24px;
      }

      .address {
        display: block;
        padding-left: 86px;
        font-size: 13px;
        color: #00a0e9;
      }
    }
  }

  .font14px {
    font-size: 14px;
  }

  .no_coupon {
    font-size: 13px;
    color: #333;
  }

  .my_coupon {
    font-size: 13px;
    color: #00a0e9;
    cursor: pointer;
    margin-left: 12px;
  }
}

.tip {
  color: rgb(242, 174, 128);
  font-weight: bold;
  font-size: 12px;
  height: 15px;
  line-height: 15px;
  margin-left: 20px;
}

.agreement {
  color: #00a0e9;
  cursor: pointer;
}

/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00a0e9;
  border-color: #00a0e9;
}

/deep/.el-checkbox__inner:hover {
  border-color: #00a0e9 !important;
}
</style>